import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import NormalViewForm from "../components/dynamic-form/NormalViewForm";
import TableView from "../components/table-view/TableView";
import DeleteIcon from '@mui/icons-material/Delete';
import api from "../services/api";
import SaveIcon from '@mui/icons-material/Save';
import { Chip, Tooltip } from "@mui/material";
import { Box , Button, FormControl, InputAdornment, Typography, IconButton, Checkbox, Grid, Autocomplete, TextField} from "@mui/material";
import TextFieldInput from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle"
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import SearchIcon from "@mui/icons-material/Search";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import Link from "@mui/material/Link";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import pdfIcon from "../Images/pdfIcon.svg";
import docIcon from "../Images/docIcon.svg";
import docxIcon from "../Images/docxIcon.svg";
import xlsIcon from "../Images/xlsIcon.svg";
import pptIcon from "../Images/pptIcon.svg";
import jpgIcon from "../Images/jpgIcon.svg";
import pngIcon from "../Images/pngIcon.svg";
import FilterListIcon from "@mui/icons-material/FilterList";
import MultiSelect from "../components/form/MultiSelect";
import AutocompleteField from "../components/form/AutoComplete";
import DateField from "../components/form/Date";
import DateTimeField from "../components/form/DateTime";
import TimeField from "../components/form/Time";
import ShortText from "../components/form/ShortText";
import WestIcon from '@mui/icons-material/West';
import { Tabs, Tab } from '@mui/material';
import { CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import SelectField from "../components/form/Select";
import dayjs from "dayjs";

const ProgressReport = ({ templateName, headerDetails, rowId, options, selectedRowData, backNavigation, showMagazineView ,fetchCounts}) => {

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (rowId) {
  //       // await checkPdfEntryStatus(rowId);
  //       getUploadedFiles(rowId, options);
  //     }
  //   };

  //   fetchData();
  // }, [rowId]);

  const [selectedTab, setSelectedTab] = useState(0);
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  const location = useLocation();
  const navigate = useNavigate();
  const { pageCount, systemStatus } = location.state || {};
  const [aoFields, setAoFields] = useState([]);
  const [aoFieldId, setAoFieldId] = useState(selectedRowData);
  const [filterAoValues, setFilterAoValues] = useState({});
  var userPermissions = JSON.parse(localStorage.getItem("user_permissions")) || [];
  const templateActionAddFlag = useRef(false);
  const [disableEditButtonFlag, setDisableEditButtonFlag] = useState(false);
  const [showPtCaseModal, setShowPtCaseModal] = useState(false);
  const [ptCaseTableName, setPtCaseTableName] = useState(null);
  const [ptCaseTemplateName, setPtCaseTemplateName] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [filterDropdownObj, setfilterDropdownObj] = useState([]);
  const [filterValues, setFilterValues] = useState({});
  const [showReplacePdfButton, setShowReplacePdfButton] = useState(false);
  const [isSubmitAllowed, setIsSubmitAllowed] = useState(false);
  const [showSubmitAPButton, setShowSubmitAPButton] = useState(false);
  const [isImmediateSupervisior, setIsImmediateSupervisior] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [rowComments, setRowComments] = useState({}); // Store comments for each row
  const [showCommentBoxes, setShowCommentBoxes] = useState({}); // Store visibility for each row
  const [approvalDialogOpen, setApprovalDialogOpen] = useState(false);
  const [approvalComment, setApprovalComment] = useState("");
  const [approvalDate, setApprovalDate] = useState(null);
  const [otherTemplatesTotalPage, setOtherTemplatesTotalPage] = useState(0);
  const [otherTemplatesTotalRecord, setOtherTemplatesTotalRecord] = useState(0);
  const [APIsSubmited, setAPIsSubmited] = useState(false);
  const [otherTemplatesPaginationCount, setOtherTemplatesPaginationCount] = useState(1);
  const [otherSearchValue, setOtherSearchValue] = useState('');
  const [othersFilterModal, setOthersFilterModal] = useState(false);
  const [othersFromDate, setOthersFromDate] = useState(null);
  const [othersToDate, setOthersToDate] = useState(null);
  const [othersFiltersDropdown, setOthersFiltersDropdown] = useState([]);
  const [othersFilterData, setOthersFilterData] = useState({});
  const [selectedParentId, setSelectedParentId] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const handleOtherPagination = (page) => {
    setOtherTemplatesPaginationCount(page)
  }

  // Approval Stepper State
  const [cachedSysStatus, setCachedSysStatus] = useState(null);
  const [cachedSubmitStatus, setCachedSubmitStatus] = useState(null);
  const [paginationCount, setPaginationCount] = useState(pageCount ? pageCount : 1);
  const [isValid, setIsValid] = useState(false);
  const [table_name, setTable_name] = useState("");
  const [sysStatus, setSysSattus] = useState(systemStatus ? systemStatus : "ui_case");
  const [formTemplateData, setFormTemplateData] = useState([]);
  const [initialData, setInitialData] = useState({});
  const [viewReadonly, setviewReadonly] = useState(false);
  const [editTemplateData, setEditTemplateData] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [otherFormOpen, setOtherFormOpen] = useState(false);
  const [optionStepperData, setOptionStepperData] = useState([]);
  const [optionFormTemplateData, setOptionFormTemplateData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [otherTemplateModalOpen, setOtherTemplateModalOpen] = useState(false);
  const [selectedOtherTemplate, setselectedOtherTemplate] = useState(options);
  const [otherTemplateData, setOtherTemplateData] = useState([]);
  const [otherInitialTemplateData, setOtherInitialTemplateData] = useState([]);
  const [otherReadOnlyTemplateData, setOtherReadOnlyTemplateData] = useState(false);
  const [otherEditTemplateData, setOtherEditTemplateData] = useState(false);
  const [otherRowId, setOtherRowId] = useState(null);
  const [otherTemplateId, setOtherTemplateId] = useState(null);
  const [otherTemplateColumn, setOtherTemplateColumn] = useState([
    { field: "sl_no", headerName: "S.No" },
  ]);
  const [hasPdfEntry, setHasPdfEntry] = useState(false);
  const [hoverTableOptions, setHoverTableOptions] = useState([]);
  const [otherTablePagination, setOtherTablePagination] = useState(1);
  const PageSize = 5;
  const [monthwiseData, setMonthwiseData] = useState([]);
  const [monthwiseTotalRecord, setMonthwiseTotalRecord] = useState(0);
  const [monthwiseTotalPage, setMonthwiseTotalPage] = useState(1);
  const [monthwiseCurrentPage, setMonthwiseCurrentPage] = useState(1);
  const [allMonthwiseSubmissions, setAllMonthwiseSubmissions] = useState([]);
  const [selectedRow, setSelectedRow] = useState(selectedRowData);
  const [selectedOtherFields, setSelectedOtherFields] = useState(null);
  const [selectKey, setSelectKey] = useState(null);
  const [randomApprovalId, setRandomApprovalId] = useState(0);
  const hoverTableOptionsRef = useRef([]);
  const [submissionDateDialogOpen, setSubmissionDateDialogOpen] = useState(false);
  const [submissionDate, setSubmissionDate] = useState(null);
  const [childTables, setChildTables] = useState([]);
  const handleMonthwisePagination = (page) => {
    getMonthWiseFile(selectedRow, page);
  };

  const monthwiseColumns = [
    {
      headerName: "S.No",
      field: "serial_no",
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const currentPage = monthwiseCurrentPage || 1;
        const pageSize = PageSize || 5;

        if (!params.row) {
          console.error("S.No - Row data is missing for serial number calculation.");
          return "-";
        }
        const rowIndex = monthwiseData.indexOf(params.row);
        const serialNumber = (currentPage - 1) * pageSize + rowIndex + 1;
        return "PR" + serialNumber;
      },
    },
    {
      headerName: "Month of Submission",
      field: "month_of_the_file",
      width: 250,
      renderCell: (params) => {
        const fileName = params.row.month_of_the_file || "";
        return fileName;
      },
    },
    {
      headerName: "File",
      field: "monthwise_file_name",
      width: 300,
      renderCell: (params) => {
        const fileName = params.row.monthwise_file_name;
        const filePath = params.row.monthwise_file_path;
        return fileUploadTableView("monthwise", { row: params.row }, fileName, filePath);
      },
    },
  ];

  const loadValueField = async (rowData, editData, table_name) => {
    if (!table_name || table_name === "") {
      toast.warning("Please Check Table Name", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "toast-warning",
      });
      return [];
    }

    var viewTemplatePayload = {
      table_name: table_name,
      id: rowData.id || rowData,
    };

    setLoading(true);

    try {
      const viewTemplateData = await api.post(
        "/templateData/viewTemplateData",
        viewTemplatePayload
      );
      setLoading(false);

      if (viewTemplateData && viewTemplateData.success) {
        const formValues = viewTemplateData.data ? viewTemplateData.data : {};

        setInitialData(formValues);
        setFilterAoValues(formValues);
        setviewReadonly(!editData);
        setEditTemplateData(editData);

        return formValues;  // Ensure values are returned properly
      } else {
        toast.error(viewTemplateData.message || "Error loading template data.", {
          position: "top-right",
          autoClose: 3000,
          className: "toast-error",
        });
        return [];
      }
    } catch (error) {
      setLoading(false);
      toast.error("Error fetching template data. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        className: "toast-error",
      });
      return [];
    }
  };

  const loadAOFields = async () => {
    setLoading(true);
    try {
      const response = await api.post("/templates/viewTemplate", {
        table_name: "cid_under_investigation",
      });

      if (response.success && response.data?.fields) {
        let aoOnlyFields = response.data.fields.filter(
          (field) =>
            field.ao_field === true &&
            field.hide_from_ux === false &&
            field.name !== "field_act" &&
            field.name !== "field_section"
        );

        const briefFactField = response.data.fields.find((f) => f.name === "field_brief_fact");
        const policeStationField = response.data.fields.find((f) => f.name === "field_investigation_carried_out_by_the_police_station");

        if (briefFactField && !aoOnlyFields.includes(briefFactField)) aoOnlyFields.push(briefFactField);
        if (policeStationField && !aoOnlyFields.includes(policeStationField)) aoOnlyFields.push(policeStationField);

          for (const field of aoOnlyFields) {
            if (field && field.api) {
              const payloadApi = field.api;
              const apiPayload = {};

              try {
                  if (field.api === "/templateData/getTemplateData") {
                  const table_name = field.table;
                  apiPayload.table_name = table_name;
                  const res = await api.post(payloadApi, apiPayload);
                  if (!res.data) {
                      field.options = [];
                      continue;
                  }
                  let headerName = "name";
                  let headerId = "id";
                  const updatedOptions = res.data.map((item) => {
                      headerName =
                      Object.keys(item).find(
                          (key) =>
                          !["id", "created_at", "updated_at"].includes(key)
                      ) || "name";
                      headerId = "id";
                      return {
                      name: item[headerName],
                      code: item[headerId],
                      };
                  });
                  field.options = updatedOptions;
                  continue;
                  }

                  const res = await api.post(payloadApi, apiPayload);
                  if (!res.data) {
                  field.options = [];
                  continue;
                  }
                  let headerName = "name";
                  let headerId = "id";
                  if (field.table === "users") {
                  headerName = "name";
                  headerId = "user_id";
                  } else if (field.api !== "/templateData/getTemplateData") {
                  headerName = field.table + "_name";
                  headerId = field.table + "_id";
                  }
                  const updatedOptions = res.data.map((item) => ({
                  name: item[headerName],
                  code: item[headerId],
                  }));
                  field.options = updatedOptions;
              } catch (err) {
                  console.error(`Error loading options for field ${field.name}`, err);
                  field.options = [];
              }
              }
          }

        setAoFields(aoOnlyFields);
        loadValueField(aoFieldId, false, "cid_under_investigation");
      }
    } catch (error) {
      toast.error("Failed to load AO fields", {
        position: "top-right",
        autoClose: 3000,
        className: "toast-error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAOFields();
  }, [selectedOtherTemplate, aoFieldId]);

  useEffect(() => {
    const fetchData = async () => {
      if (selectedTab === 0 || selectedTab === 1) {
        // When switching between tabs 0 and 1, preserve pagination
        // Only reset to page 1 if coming from a different tab (2 or 3)
        const shouldResetPage = selectedTab !== 0 && selectedTab !== 1;
        if (shouldResetPage) {
          setOtherTemplatesPaginationCount(1);
        }
        await handleOtherTemplateActions(options, selectedRowData, shouldResetPage, true);
      } else if (selectedTab === 2) {
        await getMonthWiseFile(rowId);
      }
    };

    fetchData();
  }, [selectedTab, rowId]);

  // Refetch data when pagination changes for other templates
  // Use a ref to track if this is the initial mount to avoid double fetch
  const isInitialMount = useRef(true);
  
  useEffect(() => {
    // Skip on initial mount - the first useEffect will handle initial data fetch
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    const fetchData = async () => {
      if ((selectedTab === 0 || selectedTab === 1) && selectedRowData) {
        await handleOtherTemplateActions(options, selectedRowData, false, false);
      }
    };

    fetchData();
  }, [otherTemplatesPaginationCount]);

  useEffect(() => {
    if (selectedTab === 3) {
      const caseId = selectedRow?.id || selectedRow || rowId;
      if (caseId) {
        getUploadedFiles(caseId, options);
      }
    }
  }, [selectedTab, selectedRow, rowId]);


    // start --- bulk upload functions

    const [bulkUploadShow, setBulkUploadShow] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const showBulkUploadScreen = ()=>{
        setBulkUploadShow(true);
        setSelectedFile(null);
    }
    
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const downloadExcelHeader = async ()=>{
        
        if(!options.table){
            toast.error('Template Not Found !', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toast-error",
            });
            return;
        }

        const downloadReport = {
            "table_name": options.table,
        }
        setLoading(true);

        try {
            const downloadReportResponse = await api.post("templateData/downloadExcelData", downloadReport);
            setLoading(false);

            if (downloadReportResponse) {
                const blob = new Blob([downloadReportResponse], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `${options.table}_Report.xlsx`;

                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                window.URL.revokeObjectURL(url);

            } else {
                const errorMessage = downloadReportResponse.message ? downloadReportResponse.message : "Failed to download report. Please try again.";
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    className: "toast-error",
                });
            }

        } catch (error) {
            setLoading(false);
            if (error && error.response && error.response['data']) {
                toast.error(error.response['data'].message ? error.response['data'].message : 'Please Try Again !', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    className: "toast-error",
                });
            }
        }
    }

    const checkUploadedFile = async ()=> {

        if(!options?.table){
            toast.error('Template Not Found !', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toast-error",
            });
            return;
        }

        if (!selectedFile) {
            toast.error('Please upload a file !', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toast-warning",
            });
            return;
        }

        const allowedExtensions = ['.xlsx', '.xls'];
        const fileName = selectedFile.name.toLowerCase();
        const isValid = allowedExtensions.some(ext => fileName.endsWith(ext));

        if (!isValid) {
            toast.error('Invalid file format. Please upload a valid Excel file (.xls or .xlsx) !', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toast-warning",
            });
            return;
        }

        const reader = new FileReader();

        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            const headerColumn = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
            })[0];
            
            const jsonData = XLSX.utils.sheet_to_json(worksheet);

            // remove unwanted column

            var ui_case_id = selectedRowData?.id;
            var pt_case_id = selectedRowData?.pt_case_id;

            if(module === "pt_case"){
                ui_case_id = selectedRowData?.ui_case_id
                pt_case_id = selectedRowData?.id
            }

            const rowExcelData = jsonData.map(({ __rowNum__, ...rest }) => ({...rest, ui_case_id, pt_case_id }));

            if(rowExcelData.length === 0 || headerColumn.length === 0){
                toast.error('Excel Data and Header is Empty', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    className: "toast-warning",
                });
                return
            }

            var payloadData = {
                "table_name" : options?.table,
                "rowData" : rowExcelData,
                "columnData": headerColumn
            }

            setLoading(true);
            try {
                const bulkInsertResponse = await api.post("templateData/bulkInsertData", payloadData);
                setLoading(false);

                if (bulkInsertResponse?.success) {
                    toast.success(bulkInsertResponse.message || "Data Uploaded Successfully", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        className: "toast-success",
                        onOpen: () => { handleOtherTemplateActions(options, selectedRow) }
                    });

                    if(fetchCounts){
                        fetchCounts();
                    }
                    setBulkUploadShow(false);
                    setSelectedFile(null);

                } else {
                    toast.error(bulkInsertResponse.message || "Failed to Upload Data.", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        className: "toast-error",
                    });
                }

            } catch (error) {
                setLoading(false);
                if (error && error.response && error.response['data']) {
                    toast.error(error.response['data'].message ? error.response['data'].message : 'Please Try Again !', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        className: "toast-error",
                    });
                }
            }

        };

        reader.readAsArrayBuffer(selectedFile);
    }

    // end --- bulk upload functions
          
  const onSaveTemplateError = (error) => {
    setIsValid(false);
  };

  const toggleSelectRow = (id) => {
    setSelectedRowIds((prevSelectedIds) => {
      const updated = prevSelectedIds.includes(id)
        ? prevSelectedIds.filter((selectedId) => selectedId !== id)
        : [...prevSelectedIds, id];

      // Keep selectedIds in sync (used in submit flows)
      setSelectedIds(updated);
      return updated;
    });
  };

  const handleOtherTemplateActions = async (options, selectedRow, searchFlag, fromUploadedFiles) => {

    const randomId = `random_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
    setRandomApprovalId(randomId);

    let disabledEditFlag = false;
    let disabledDeleteFlag = false;

    let getTemplatePayload = {
      table_name: options.table || options,
      ui_case_id: selectedRow.id || selectedRow,
      case_io_id: selectedRow.field_io_name || "",
      pt_case_id: selectedRow?.pt_case_id || null,
      limit: 10,
      page: !searchFlag ? otherTemplatesPaginationCount : 1,
      search: !searchFlag ? otherSearchValue : "",
      from_date: !searchFlag ? othersFromDate : null,
      to_date: !searchFlag ? othersToDate : null,
      filter: !searchFlag ? othersFilterData : {},
    };


    // Permissions handling
    if (options.permissions) {
      try {
        const parsedPermissions = JSON.parse(options.permissions);

        if (parsedPermissions?.["add"]) {
          const hasAddPermission = parsedPermissions["add"].some(
            (p) => userPermissions?.[0]?.[p] === true
          );
          templateActionAddFlag.current = hasAddPermission;
        } else {
          templateActionAddFlag.current = true;
        }

        if (parsedPermissions?.["edit"]) {
          const hasEditPermission = parsedPermissions["edit"].some(
            (p) => userPermissions?.[0]?.[p] === true
          );
          disabledEditFlag = hasEditPermission;
        } else {
          disabledEditFlag = true;
        }

        if (parsedPermissions?.["delete"]) {
          const hasDeletePermission = parsedPermissions["delete"].some(
            (p) => userPermissions?.[0]?.[p] === true
          );
          disabledDeleteFlag = hasDeletePermission;
        } else {
          disabledDeleteFlag = true;
        }
      } catch (e) {
        console.warn("Failed to parse permissions", e);
      }
    }

    setLoading(true);

    try {
      const getTemplateResponse = await api.post("/templateData/getTemplateData", getTemplatePayload);
      setLoading(false);

      if (getTemplateResponse && getTemplateResponse.success) {
        const { meta } = getTemplateResponse;

        const currentDate = meta?.currentDate;
        const dayOfMonth = new Date(currentDate).getDate();
        // const isSubmitAllowed = dayOfMonth >= 24 && dayOfMonth <= 30;
        // setIsSubmitAllowed(isSubmitAllowed);

        
      // Note: isSubmitAllowed will be recalculated in useEffect when allMonthwiseSubmissions is loaded
      // This ensures it matches the checkbox visibility logic
      setIsSubmitAllowed(false);


        const totalPages = meta?.meta?.totalPages;
        const totalItems = meta?.meta?.totalItems;

        setOtherTemplatesTotalPage(totalPages);
        setOtherTemplatesTotalRecord(totalItems);

        const records = getTemplateResponse.data || [];

        // Show/hide Replace PDF Button
        let showReplacePdf = false;
        if (selectedOtherTemplate?.table || options.table === "cid_ui_case_progress_report") {
          const anyHasPRStatus = records.some(record => record.field_pr_status === "Yes");
          if (!anyHasPRStatus) {
            showReplacePdf = true;
          }
        }

        setShowReplacePdfButton(showReplacePdf);

        // Submit logic
        let APisSubmited = false;
        let anySubmitAP = true;
        let isSupervisor = false;
        const userDesigId = localStorage.getItem('designation_id');

        if (records.length > 0) {
          const allAPWithSameSupervisor = records.every(
            record => (record.field_submit_status === "" || record.field_submit_status === null) &&
              record.supervisior_designation_id == userDesigId
          );

          const allAPWithoutIOSubmit = records.every(
            record => (record.sys_status === "ui_case") &&
              (record.field_submit_status === "" || record.field_submit_status === null) &&
              record.supervisior_designation_id != userDesigId
          );

          if (allAPWithSameSupervisor || allAPWithoutIOSubmit) {
            anySubmitAP = false;
          }

          if (allAPWithSameSupervisor) isSupervisor = true;

          APisSubmited = records.every(
            record => record.sys_status === "ui_case" ||
              (record.sys_status === "IO" &&
                (record.field_submit_status === "" || record.field_submit_status === null) &&
                record.supervisior_designation_id != userDesigId)
          );
        }

        setShowSubmitAPButton(anySubmitAP);
        setIsImmediateSupervisior(isSupervisor);
        setAPIsSubmited(APisSubmited);

        // Cache sys_status and field_submit_status for stepper
        if (records[0]) {
          setCachedSysStatus(records[0].sys_status);
          setCachedSubmitStatus(records[0].field_submit_status);
        }

        if (records[0]) {
          const excludedKeys = [
            "updated_at", "id", "deleted_at", "attachments", "Starred", "ReadStatus",
            "linked_profile_info", "sys_status", "field_submit_status",
            "supervisior_designation_id",
            "approval_field_array",
            "io_selected_record_ids",
            "field_approval_done_by",
            "sp_comment",
            "dig_comment",
            "adgp_comment",
            "dgp_comment",
            "approve_action"
          ];

           const updatedHeader = [
            {
              field: "select",
              headerName: "",
              width: 50,
              cellClassName: (params) => getCellClassName("sl_no", params, options.table),
              renderCell: (params) => {
                const roleTitle = JSON.parse(localStorage.getItem("role_title")) || "";
                const isIO = roleTitle.toLowerCase() === "investigation officer";
                
                // STRICT: Only render checkbox column if user is IO or if there are IO selected records
                // This prevents checkbox from always rendering
                if (!isIO) {
                  // For non-IO users, only show if IO has selected records (will be checked later)
                  // But return early if we can determine there are no IO selections
                  const hasIOSelections = otherTemplateData && otherTemplateData.length > 0 && 
                    otherTemplateData[0]?.io_selected_record_ids;
                  if (!hasIOSelections) {
                    return null;
                  }
                }
                
                // Check if PDF is updated for this record
                const isPdfUpdated = params.row.field_pr_status === "Yes";
                
                // Hide checkboxes if:
                // 1. PDF is updated (this month completed) AND date is after 25th
                // 2. For records where PDF is NOT updated, always show checkbox (could be next month or not yet updated)
                if (isPdfUpdated && !isSubmitAllowed) {
                  return null;
                }
                
                // Check if DGP has submitted by checking approval_field_array
                let dgpHasSubmitted = false;
                try {
                  if (params.row.approval_field_array) {
                    const approvalArray = typeof params.row.approval_field_array === "string"
                      ? JSON.parse(params.row.approval_field_array)
                      : params.row.approval_field_array;
                    if (Array.isArray(approvalArray) && approvalArray.includes("DGP")) {
                      dgpHasSubmitted = true;
                    }
                  }
                } catch (e) {
                  // Error parsing approval_field_array
                }
                
                // If DGP has submitted, hide checkboxes for all roles except IO
                if (dgpHasSubmitted && !isIO) {
                  return null;
                }
                
                // Get io_selected_record_ids from the first record (all records should have the same value)
                let ioSelectedRecordIds = [];
                if (otherTemplateData && otherTemplateData.length > 0) {
                  const firstRecord = otherTemplateData[0];
                  if (firstRecord.io_selected_record_ids) {
                    try {
                      ioSelectedRecordIds = typeof firstRecord.io_selected_record_ids === "string"
                        ? JSON.parse(firstRecord.io_selected_record_ids)
                        : firstRecord.io_selected_record_ids;
                    } catch (e) {
                      // Error parsing io_selected_record_ids
                    }
                  }
                }
                
                // Check if this row ID is in IO's selected records
                const isSelectedByIO = ioSelectedRecordIds.includes(params.row.id);
                
                // For IO: show checkbox (enabled) ONLY if ALL conditions are met
                if (isIO) {
                  const isPdfUpdated = params.row.field_pr_status === "Yes";
                  const normalizedStatus = (params.row.field_status || "").toLowerCase().replace(/\s+/g, "");
                  const isPdfUpdating = normalizedStatus === "completed" || normalizedStatus === "inprogress";
                  
                  // Check if IO has already submitted by checking approval_field_array
                  let alreadySubmittedByIO = false;
                  try {
                    if (params.row.approval_field_array) {
                      const approvalArray = typeof params.row.approval_field_array === "string"
                        ? JSON.parse(params.row.approval_field_array)
                        : params.row.approval_field_array;
                      if (Array.isArray(approvalArray) && approvalArray.includes("IO")) {
                        alreadySubmittedByIO = true;
                      }
                    }
                  } catch (e) {
                    // Fallback to checking field_submit_status and sys_status
                    alreadySubmittedByIO =
                      (params.row.field_submit_status || "").toLowerCase() === "submit" &&
                      (params.row.sys_status || "").toLowerCase() === "io";
                  }

                  // Check month submission logic based on latest submission date
                  // This determines if checkbox should be hidden based on month submission rules
                  const shouldHideCheckboxDueToMonth = calculateShouldHideSubmissionDueToMonth(allMonthwiseSubmissions);

                  // STRICT: Hide checkbox if ANY condition is not met
                  // Checkbox should ONLY show when:
                  // 1. PDF is NOT updated (field_pr_status !== "Yes")
                  // 2. PDF is updating (status is "completed" or "inprogress")
                  // 3. IO has NOT already submitted
                  // 4. Month submission rules allow it
                  if (isPdfUpdated || !isPdfUpdating || alreadySubmittedByIO || shouldHideCheckboxDueToMonth) {
                    return null;
                  }

                  // Only render checkbox if ALL conditions pass
                  return (
                    <div onClick={(e) => e.stopPropagation()}>
                      <Checkbox 
                        onChange={(event) => {
                          event.stopPropagation();
                          toggleSelectRow(params.row.id);
                        }}
                      />
                    </div>
                  );
                }
                
                // For SP/DIG/ADGP/DGP: show checkbox (disabled) with IO's selection
                // Only show if IO has selected records
                if (ioSelectedRecordIds.length > 0) {
                  return (
                    <div onClick={(e) => e.stopPropagation()}>
                      <Checkbox 
                        checked={isSelectedByIO}
                        disabled={true}
                        sx={{
                          '&.Mui-disabled': {
                            color: '#9e9e9e', // Grey color for disabled checkboxes
                          },
                          '&.Mui-checked.Mui-disabled': {
                            color: '#9e9e9e', // Grey color even when checked and disabled
                          }
                        }}
                      />
                    </div>
                  );
                }
                
                // If no IO selection, don't show checkbox for non-IO users
                return null;
              },
            },
            {
              field: "sl_no",
              headerName: "S.No",
              resizable: false,
              width: 75,
              renderCell: (params) => {
                const isPdfUpdated = params.row.field_pr_status === "Yes";
                const userPermissions = JSON.parse(localStorage.getItem("user_permissions")) || [];
                const canDelete = userPermissions[0]?.action_delete;
                const isViewAction = options.is_view_action === true;

                return (
                  <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    {params.value}
                    {canDelete && !isViewAction && !isPdfUpdated && (
                      <DeleteIcon
                        sx={{ cursor: "pointer", color: "red", fontSize: 20 }}
                        onClick={(event) => {
                          event.stopPropagation();
                          handleOthersDeleteTemplateData(params.row, options.table,selectedRow.id || selectedRow);
                        }}
                      />
                    )}
                  </Box>
                );
              },
            },
            {
              field: "sys_status",
              headerName: "From",
              width: 140,
              resizable: true,
              sortable: true,
              cellClassName: (params) => getCellClassName("sl_no", params, options.table),
              sortComparator: (v1, v2) => {
                if (v1 === "AP" && v2 === "ui_case") return -1;
                if (v1 === "ui_case" && v2 === "AP") return 1;
                return 0;
              },
              renderCell: (params) => {
                const statusText = params.value === "AP" ? "Action Plan" : "Progress Report";
                const isUpdated = params.value === "AP";

                return (
                  <Chip
                    label={statusText}
                    size="small"
                    sx={{
                      width: '120px',
                      fontFamily: "Roboto",
                      fontWeight: 600,
                      fontSize: "12px",
                      color: "#1f2937",
                      backgroundColor: isUpdated ? "#bfdbfe" : "#fef3c7",
                      borderRadius: "6px",
                      padding: "3px",
                      border: isUpdated ? "1px dashed #3b82f6" : "1px dashed #f59e0b",
                      textTransform: "capitalize",
                    }}
                  />
                );
              },
            },

            {
              field: "field_action_item",
              headerName: "Action Item",
              width: 200,
              resizable: true,
              cellClassName: (params) => getCellClassName("field_action_item", params, options.table),
              renderHeader: () => (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                  <span style={{ color: "#1D2939", fontSize: "15px", fontWeight: "500" }}>Action Item</span>
                </div>
              ),
              renderCell: (params) => {
                const isPdfUpdated = params.row.field_pr_status === "Yes";
                const userPermissions = JSON.parse(localStorage.getItem("user_permissions")) || [];
                const canEdit = userPermissions[0]?.action_edit;
                const isViewAction = options.is_view_action === true;
                const isEditAllowed = canEdit && !isViewAction && !isPdfUpdated;

                return (
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOthersTemplateDataView(params.row, false, options.table, !isEditAllowed);
                    }}
                    style={{
                      color: '#2563eb',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      fontWeight: 400,
                      fontSize: '14px'
                    }}
                  >
                    {params.value || 'View'}
                  </span>
                );
              }
            },

            ...Object.keys(getTemplateResponse.data[0])
              .filter((key) =>
                !excludedKeys.includes(key) &&
                ![
                  "field_action_item",
                  "created_at",
                  "field_pt_case_id",
                  "field_ui_case_id",
                  "field_pr_status",
                  "field_evidence_file",
                  "created_by",
                  "field_last_updated",
                  "field_date_created",
                  "field_description",
                  "field_assigned_to_id",
                  "field_assigned_by_id",
                  "field_served_or_unserved",
                  "field_reappear",
                  "hasFieldPrStatus",
                  "approval_field_array",
                  "io_selected_record_ids",
                  "sp_comment",
                  "dig_comment",
                  "adgp_comment",
                  "dgp_comment",
                  "approve_action"
                ].includes(key)
              )
              .map((key) => {
                const updatedKeyName = key
                  .replace(/^field_/, "")
                  .replace(/_/g, " ")
                  .toLowerCase()
                  .replace(/^\w|\s\w/g, (c) => c.toUpperCase());

                return {
                  field: key,
                  headerName: updatedKeyName || "",
                  width: 200,
                  resizable: true,
                  cellClassName: (params) => getCellClassName(key, params, options.table),
                  renderHeader: () => (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                      <span style={{ color: "#1D2939", fontSize: "15px", fontWeight: "500" }}>
                        {updatedKeyName || "-"}
                      </span>
                    </div>
                  ),
                  renderCell: (params) => tableCellRender(key, params, params.value),
                };
              }),

            

            {
              field: "field_pr_status",
              headerName: "PDF Status",
              width: 150,
              resizable: true,
              sortable: true,
              cellClassName: (params) => getCellClassName("sl_no", params, options.table),
              sortComparator: (v1, v2) => {
                if (v1 === "Yes" && v2 === "No") return -1;
                if (v1 === "No" && v2 === "Yes") return 1;
                return 0;
              },
              renderCell: (params) => {
                const isUpdated = params.value === "Yes";
                const statusText = isUpdated ? "PDF Updated" : "Not Updated";
                const statusColor = isUpdated ? "#22c55e" : "#ef4444";
                const borderColor = isUpdated ? "#34D399" : "#EF4444";

                return (
                  <Chip
                    label={statusText}
                    size="small"
                    sx={{
                      fontFamily: "Roboto",
                      fontWeight: 400,
                      color: "white",
                      borderColor: borderColor,
                      borderRadius: "4px",
                      backgroundColor: statusColor,
                      textTransform: "capitalize",
                      borderStyle: "solid",
                      borderWidth: "1px",
                    }}
                  />
                );
              },
            },

            ...(Object.keys(getTemplateResponse.data[0]).includes("created_at") ? [{
              field: "created_at",
              headerName: "Created At",
              width: 200,
              resizable: true,
              renderHeader: () => (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                  <span style={{ color: "#1D2939", fontSize: "15px", fontWeight: "500" }}>Created At</span>
                </div>
              ),
              renderCell: (params) => tableCellRender("created_at", params, params.row.created_at)
            }] : [])
          ].filter(Boolean);



          setOtherTemplateColumn(updatedHeader);
        }

        const formatDate = (value) => {
          const parsed = Date.parse(value);
          return isNaN(parsed) ? value : new Date(parsed).toLocaleDateString("en-GB");
        };

        const updatedTableData = records.map((field, index) => {
          const updatedField = {};

          Object.keys(field).forEach((key) => {
            updatedField[key] = (field[key] && isValidISODate(field[key])) ? formatDate(field[key]) : field[key];
          });

          // Use otherTemplatesPaginationCount for serial number calculation to match the actual pagination
          const currentPage = !searchFlag ? otherTemplatesPaginationCount : 1;
          const pageSize = 10; // Based on limit: 10 in getTemplatePayload
          
          // Calculate approval status for filtering
          const defaultApprovalSteps = ["IO", "SP", "DIG", "ADGP", "DGP"];
          const approvalStepperArray = options?.approval_steps 
            ? (typeof options.approval_steps === "string" ? JSON.parse(options.approval_steps) : options.approval_steps)
            : defaultApprovalSteps;
          
          let approvalArray = [];
          try {
            if (updatedField.approval_field_array) {
              approvalArray = typeof updatedField.approval_field_array === "string"
                ? JSON.parse(updatedField.approval_field_array)
                : updatedField.approval_field_array;
            }
          } catch (e) {
            approvalArray = [];
          }
          
          let approvalStatus = "IO Pending";
          if (approvalArray.length > 0) {
            const lastApprovedRole = approvalArray[0];
            const lastApprovedIndex = approvalStepperArray.indexOf(lastApprovedRole);
            
            if (lastApprovedIndex !== -1 && lastApprovedIndex < approvalStepperArray.length - 1) {
              const nextApprover = approvalStepperArray[lastApprovedIndex + 1];
              approvalStatus = `${nextApprover} Pending`;
            } else if (lastApprovedIndex === approvalStepperArray.length - 1) {
              approvalStatus = "DGP Approved";
            }
          } else {
            const sysStatus = updatedField.sys_status || "";
            const fieldSubmitStatus = updatedField.field_submit_status || "";
            
            if (sysStatus === "IO" && fieldSubmitStatus === "submit") {
              approvalStatus = "SP Pending";
            } else if (sysStatus === "IO") {
              approvalStatus = "IO Pending";
            }
          }
          
          return {
            ...updatedField,
            sl_no: (currentPage - 1) * pageSize + (index + 1),
            approval_status: approvalStatus, // Add status for filtering
            ...(field.id ? {} : { id: `unique_id_${index}` }),
          };
          
        });

        setOtherTemplateData(updatedTableData);

        if (options.table === "cid_ui_case_progress_report" && options.is_pdf && !fromUploadedFiles && selectedTab === 3) {
          // await checkPdfEntryStatus(selectedRow.id);
          await getUploadedFiles(selectedRow, options);
        }

        setOtherTemplateModalOpen(true);
      } else {
        console.warn("API call failed or returned no success flag.");
      }

      setOtherFormOpen(false);
      setOptionStepperData([]);
      setOptionFormTemplateData([]);
    } catch (error) {
      console.error("API Error:", error);
      setLoading(false);
      toast.error(error?.response?.data?.message || "Please try again!", {
        position: "top-right",
      });
    }
  };

  const handleOthersTemplateDataView = async (
    rowData,
    editData,
    table_name,
    disableEditButton
  ) => {

    if (!table_name || table_name === "") {
      toast.warning("Please Check Table Name", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "toast-warning",
      });
      return;
    }

    var viewTemplatePayload = {
      table_name: table_name,
      id: rowData.id,
    };

    setLoading(true);
    try {
      const viewTemplateData = await api.post(
        "/templateData/viewTemplateData",
        viewTemplatePayload
      );
      setLoading(false);

      if (viewTemplateData && viewTemplateData.success) {
        setOtherInitialTemplateData(
          viewTemplateData.data ? viewTemplateData.data : {}
        );
        setOtherReadOnlyTemplateData(!editData);
        setOtherEditTemplateData(editData);
        setOtherRowId(null);
        setOtherTemplateId(null);

        const viewTableData = {
          table_name: table_name,
        };

        setLoading(true);
        try {
          const viewTemplateResponse = await api.post(
            "/templates/viewTemplate",
            viewTableData
          );
          setLoading(false);

          if (viewTemplateResponse && viewTemplateResponse.success) {
            const templateData = viewTemplateResponse.data;
            const rawFields = templateData.fields || [];

            const processedFields = rawFields.map((field) => {
              if (
                field.name === "field_assigned_by" &&
                templateData.table_name === "cid_ui_case_progress_report"
              ) {
                return {
                  ...field,
                  disabled: true,
                };
              }
              return field;
            });
            setOptionFormTemplateData(processedFields);
            setDisableEditButtonFlag(disableEditButton);

            setOtherFormOpen(true);
            setOtherRowId(rowData.id);
            setOtherTemplateId(viewTemplateResponse["data"].template_id);
            setChildTables(viewTemplateResponse?.["data"]?.["child_tables"] || []);
            if (
              viewTemplateResponse.data.no_of_sections &&
              viewTemplateResponse.data.no_of_sections > 0
            ) {
              setOptionStepperData(
                viewTemplateResponse.data.sections
                  ? viewTemplateResponse.data.sections
                  : []
              );
            }
          } else {
            const errorMessage = viewTemplateResponse.message
              ? viewTemplateResponse.message
              : "Failed to delete the template. Please try again.";
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              className: "toast-error",
            });
          }
        } catch (error) {
          setLoading(false);
          if (error && error.response && error.response["data"]) {
            toast.error(
              error.response["data"].message
                ? error.response["data"].message
                : "Please Try Again !",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toast-error",
              }
            );
          }
        }
      } else {
        const errorMessage = viewTemplateData.message
          ? viewTemplateData.message
          : "Failed to create the template. Please try again.";
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-error",
        });
      }
    } catch (error) {
      setLoading(false);
      if (error && error.response && error.response["data"]) {
        toast.error(
          error.response["data"].message
            ? error.response["data"].message
            : "Please Try Again !",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            className: "toast-error",
          }
        );
      }
    }
  };

  const closeOtherForm = () => {
    setOtherFormOpen(false)
    setShowPtCaseModal(false);
    if (selectedOtherTemplate?.table === "cid_ui_case_action_plan") {
      handleOtherTemplateActions(selectedOtherTemplate, selectedRowData)
    }
  }

  const getCellClassName = (key, params, table) => {
    // Example condition: unread rows for a specific table
    // if (table === "cid_ui_case_progress_report" && !params?.row?.ReadStatus) {
    //     return "unreadBackground";
    // }

    // Add more logic if needed based on `key` or `params`
    return "";
  };

  const tableCellRender = (key, params, value, index, tableName) => {
    if (params?.row?.attachments) {
      var attachmentField = params.row.attachments.find(
        (data) => data.field_name === key
      );
      if (attachmentField) {
        return fileUploadTableView(key, params, params.value);
      }
    }

    let highlightColor = {};
    let onClickHandler = null;

    if (tableName && index !== null && index === 0) {
      highlightColor = { color: '#0167F8', textDecoration: 'underline', cursor: 'pointer' };

      onClickHandler = (event) => { event.stopPropagation(); handleTemplateDataView(params.row, false, tableName, hoverTableOptions) };
    }


    return (
      <Tooltip title={value} placement="top">
        {
          (key === "field_io_name" && (value === "" || !value)) ? (
            <span className="io-alert-flashy">
              <span className="flashy-dot"></span>
              ASSIGN IO
            </span>
          ) : (
            <span
              style={highlightColor}
              onClick={onClickHandler}
              className={`tableValueTextView Roboto`}
            >
              {value || "-"}
            </span>
          )
        }
      </Tooltip>
    );
  };

  const handleOthersDeleteTemplateData = (rowData, table_name, ui_case_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this profile ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const deleteTemplateData = {
          table_name: table_name,
          where: { id: rowData.id },
          ui_case_id:ui_case_id,
          transaction_id : "TXN_" + Date.now() + "_" + Math.floor(Math.random() * 1000000),
        };
        setLoading(true);

        try {
          const deleteTemplateDataResponse = await api.post(
            "templateData/deleteTemplateData",
            deleteTemplateData
          );
          setLoading(false);

          if (
            deleteTemplateDataResponse &&
            deleteTemplateDataResponse.success
          ) {
            toast.success(
              deleteTemplateDataResponse.message
                ? deleteTemplateDataResponse.message
                : "Template Deleted Successfully",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toast-success",
                onOpen: () =>
                  handleOtherTemplateActions(
                    selectedOtherTemplate,
                    selectedRow
                  ),
              }
            );
            if (fetchCounts) {
                fetchCounts();
            }
          } else {
            const errorMessage = deleteTemplateDataResponse.message
              ? deleteTemplateDataResponse.message
              : "Failed to delete the template. Please try again.";
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              className: "toast-error",
            });
          }
        } catch (error) {
          setLoading(false);
          if (error && error.response && error.response["data"]) {
            toast.error(
              error.response["data"].message
                ? error.response["data"].message
                : "Please Try Again !",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toast-error",
              }
            );
          }
        }
      } else {
      }
    });
  };

  function isValidISODate(value) {
    return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(value) && !isNaN(new Date(value).getTime());
  }

  const checkPdfEntryStatus = async (caseId) => {
    if (!caseId) {
      setHasPdfEntry(false);
      return;
    }
    try {
      const response = await api.post("/templateData/checkPdfEntry", {
        ui_case_id: caseId,
        is_pdf: true,
      });

      if (response.success && response.data) {
        setHasPdfEntry(true);
      } else {
        setHasPdfEntry(false);
      }
    } catch (error) {
      console.error("Error checking PDF entry:", error);
      setHasPdfEntry(false);
    }
  };

  const getUploadedFiles = async (selectedRow, options) => {
    if (!selectedRow) {
      console.error("Invalid selectedRow for file retrieval:", selectedRow);
      setUploadedFiles([]);
      return;
    }
    
    const caseId = selectedRow?.id || selectedRow;
    
    try {
      const response = await api.post("/templateData/getUploadedFiles", {
        ui_case_id: caseId,
      });


      if (response && response.success) {
        const files = response.data || [];
        setUploadedFiles(files);
        if (options) {
          handleOtherTemplateActions(options, selectedRow, false, true);
        }
      } else {
        console.warn("getUploadedFiles: Response not successful:", response);
        setUploadedFiles([]);
      }
    } catch (error) {
      console.error("Error fetching uploaded files:", error);
      setUploadedFiles([]);
    }
  };

  const checkSubmissionExistsForCurrentMonth = (data) => {
  const now = new Date();
  return data.some(item => {
    const date = new Date(item.submission_date);
    return date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
  });
};

  // Helper function to extract month name from month_of_the_file (e.g., "November Submission" -> "November")
  const extractMonthName = (monthOfFile) => {
    if (!monthOfFile) return null;
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    for (const month of monthNames) {
      if (monthOfFile.toLowerCase().includes(month.toLowerCase())) {
        return month;
      }
    }
    return null;
  };

  // Helper function to get month name from date
  const getMonthNameFromDate = (date) => {
    if (!date) return null;
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const d = new Date(date);
    return monthNames[d.getMonth()];
  };

  // Check if a month already has a submission
  const monthAlreadyHasSubmission = (monthName, allSubmissions) => {
    if (!monthName || !allSubmissions || allSubmissions.length === 0) return false;
    return allSubmissions.some(item => {
      const itemMonth = extractMonthName(item.month_of_the_file);
      return itemMonth && itemMonth.toLowerCase() === monthName.toLowerCase();
    });
  };

  // Calculate if submission should be hidden/disabled based on month submission rules
  // This is the same logic used for checkbox visibility
  const calculateShouldHideSubmissionDueToMonth = (allSubmissions) => {
    
    if (!allSubmissions || allSubmissions.length === 0) {
      return false;
    }
    
    // Get the latest submission (by submission_date)
    const latestSubmission = allSubmissions
      .filter(item => item.submission_date)
      .sort((a, b) => new Date(b.submission_date) - new Date(a.submission_date))[0];
    
    if (!latestSubmission || !latestSubmission.submission_date) {
      return false;
    }
    
    const latestSubmissionDate = new Date(latestSubmission.submission_date);
    const currentDate = new Date();
    const dayOfMonth = currentDate.getDate();
    
    console.log("  - Current date:", currentDate.toISOString());
    console.log("  - Day of month:", dayOfMonth);
    console.log("  - Latest submission date:", latestSubmissionDate.toISOString());
    
    // Get month name from latest submission date (when it was submitted)
    const latestSubmissionDateMonth = getMonthNameFromDate(latestSubmissionDate);
    
    const currentMonth = getMonthNameFromDate(currentDate);
    const lastMonthDate = new Date(currentDate);
    lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
    const lastMonth = getMonthNameFromDate(lastMonthDate);
    
    // Main logic: Check if the current month already has a submission
    // If it does, hide the checkbox to prevent duplicate submissions for the same month
    const currentMonthHasSubmission = monthAlreadyHasSubmission(currentMonth, allSubmissions);
    
    if (currentMonthHasSubmission) {
      return true;
    }
    
    // If current month doesn't have a submission, allow it
    return false;
  };

  // Fetch all monthwise submissions to check existing months
  const fetchAllMonthwiseSubmissions = async (ui_case_id) => {
    if (!ui_case_id) return;
    try {
      const response = await api.post("/templateData/getMonthWiseByCaseId", {
        ui_case_id: ui_case_id.id || ui_case_id,
        page: 1,
        limit: 1000, // Fetch all records
      });
      if (response && response.success) {
        setAllMonthwiseSubmissions(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching all monthwise submissions:", error);
    }
  };


  const getMonthWiseFile = async (ui_case_id, page = 1) => {
    if (!ui_case_id) {
      console.error("Invalid ui_case_id for file retrieval:", ui_case_id);
      return;
    }
    try {
      const response = await api.post("/templateData/getMonthWiseByCaseId", {
        ui_case_id:ui_case_id.id || ui_case_id,
        page,
        limit: PageSize,
      });

      if (response && response.success) {
        // const submissionExists = checkSubmissionExistsForCurrentMonth(response.data || []);
        // setIsSubmitAllowed(!submissionExists);
        setMonthwiseData(response.data || []);
        setMonthwiseTotalRecord(response.totalRecords || 0);
        setMonthwiseTotalPage(Math.ceil((response.totalRecords || 0) / PageSize));
        setMonthwiseCurrentPage(page);
      }
    } catch (error) {
      console.error("Error fetching monthwise files:", error);
    }
  };

  useEffect(() => {
    if (selectedRow) {
      getMonthWiseFile(selectedRow, 1);
      fetchAllMonthwiseSubmissions(selectedRow);
    }
  }, [selectedRow]);

  // Recalculate isSubmitAllowed when allMonthwiseSubmissions changes
  // This ensures submit button uses the same logic as checkbox visibility
  // If checkbox is showing, submit should also be enabled
  useEffect(() => {
    if (selectedRow) {
      // Use the same logic as checkbox: if checkbox should be hidden due to month rules, disable submit
      const shouldHideDueToMonth = calculateShouldHideSubmissionDueToMonth(allMonthwiseSubmissions);
      
      // Submit is allowed when checkbox would be visible (not hidden due to month submission rules)
      // This matches the checkbox visibility logic - if checkbox shows, submit is enabled
      setIsSubmitAllowed(!shouldHideDueToMonth);
    } else {
      // If no row selected, disable submit
      setIsSubmitAllowed(false);
    }
  }, [allMonthwiseSubmissions, selectedRow]);


  const buildFileUrl = (filePath) => {
    if (!filePath) {
      console.warn("buildFileUrl: filePath is empty");
      return "";
    }
    if (filePath.startsWith("http")) return filePath;

    let base = (process.env.REACT_APP_SERVER_URL_FILE_VIEW || "").replace(/\/$/, "");
    let normalizedPath = filePath.replace(/\\/g, '/');
    
    // Remove leading/trailing slashes from path
    normalizedPath = normalizedPath.replace(/^\/+|\/+$/g, '');
    
    // If path starts with 'files/', remove it
    if (normalizedPath.startsWith('files/')) {
      normalizedPath = normalizedPath.replace(/^files\//, '');
    }
    
    // Ensure base ends with '/files' for the static file route
    if (!base.endsWith('/files')) {
      // If base is just the server URL, append /files
      base = base.endsWith('/') ? `${base}files` : `${base}/files`;
    }
    
    // Construct final URL: base/files/filename
    const finalUrl = `${base}/${normalizedPath}`;
    return finalUrl;
  };

  const fileUploadTableView = (type, rowData, attachment, filePath) => {
    if (attachment && attachment !== "") {
      var separateAttachment = attachment.split(",");
      return (
        <Box
          sx={{ display: "flex", alignItems: "center", gap: "4px", cursor: "pointer", height: '100%' }}
          onClick={(e) => {
            e.stopPropagation();
            const url = buildFileUrl(filePath);
            window.open(url, "_blank");
          }}
        >
          <Box className="Roboto attachmentTableBox">
            <span style={{ display: "flex" }}>
              {getFileIcon(separateAttachment[0])}
            </span>
            <span className="Roboto attachmentTableName">
              {separateAttachment[0]}
            </span>
          </Box>
          {separateAttachment.length > 1 && (
            <button className="Roboto attachmentTableBtn">
              {separateAttachment.length - 1}+
            </button>
          )}
        </Box>
      );
    }
  };

  const handleTemplateDataView = async (rowData, editData, table_name) => {

    if (!table_name || table_name === "") {
      toast.warning("Please Check Table Name", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "toast-warning",
      });
      return;
    }

    var viewTemplatePayload = {
      table_name: table_name,
      id: rowData.id,
    };

    setLoading(true);

    try {

      const viewTemplateData = await api.post("/templateData/viewTemplateData", viewTemplatePayload);
      setLoading(false);

      if (viewTemplateData && viewTemplateData.success) {

        const viewTableData = {
          table_name: table_name,
        };

        setLoading(true);
        try {
          const viewTemplateResponse = await api.post("/templates/viewTemplate", viewTableData);
          setLoading(false);

          if (viewTemplateResponse && viewTemplateResponse.success) {

            var actionTemplateMenus = hoverTableOptionsRef.current.map((element) => {

              if (element?.icon && typeof element.icon === 'function') {
                element.icon = element?.icon();
              }

              return element;

            });

            var stateObj = {
              contentArray: JSON.stringify(actionTemplateMenus),
              headerDetails: rowData?.["field_cid_crime_no./enquiry_no"] || null,
              backNavigation: "/case/ui_case",
              paginationCount: paginationCount,
              sysStatus: sysStatus,
              rowData: viewTemplateData?.["data"] || {},
              tableFields: viewTemplateResponse?.["data"]?.["fields"] || [],
              stepperData: viewTemplateResponse?.["data"]?.no_of_sections > 0 && viewTemplateResponse?.["data"]?.sections ? viewTemplateResponse?.["data"].sections : [],
              template_id: viewTemplateResponse?.["data"]?.template_id,
              template_name: viewTemplateResponse?.["data"]?.template_name,
              table_name: table_name
            }

            navigate("/caseView", { state: stateObj });

          } else {
            const errorMessage = viewTemplateResponse.message ? viewTemplateResponse.message : "Failed to delete the template. Please try again.";
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              className: "toast-error",
            });
          }
        } catch (error) {
          setLoading(false);
          if (error && error.response && error.response["data"]) {
            toast.error(error.response["data"].message ? error.response["data"].message : "Please Try Again !", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              className: "toast-error",
            });
          }
        }
      } else {
        const errorMessage = viewTemplateData.message
          ? viewTemplateData.message
          : "Failed to create the template. Please try again.";
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-error",
        });
      }
    } catch (error) {
      setLoading(false);
      if (error && error.response && error.response["data"]) {
        toast.error(error.response["data"].message ? error.response["data"].message : "Please Try Again !", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-error",
        });
      }
    }
  };

  const setOtherFilterData = () => {
        setOtherTemplatesPaginationCount(1);
        setOthersFilterModal(false);
        handleOtherTemplateActions(selectedOtherTemplate, selectedRowData)
    };
  const handleOthersFilter = async (selectedOptions) => {

    if (!selectedOptions?.table) {
      toast.error('Please Check The Template', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "toast-error",
      });
      return false;
    }

    const viewTableData = { table_name: selectedOptions.table };

    setLoading(true);
    try {
      const viewTemplateResponse = await api.post("/templates/viewTemplate", viewTableData);
      setLoading(false);

      if (viewTemplateResponse && viewTemplateResponse.success && viewTemplateResponse.data) {
        var templateFields = viewTemplateResponse.data["fields"] ? viewTemplateResponse.data["fields"] : [];
        var validFilterFields = ["dropdown", "autocomplete", "multidropdown", "date", "datetime", "time", ];

        var getOnlyDropdown = templateFields.filter((element) => validFilterFields.includes(element.type)).map((field) => {
          const existingField = filterDropdownObj?.find(
            (item) => item.name === field.name
          );
          return {
            ...field,
            history: false,
            info: false,
            required: false,
            ...(field.is_dependent === "true" && { options: existingField?.options ? [...existingField.options] : [] }),
          };
        });

        // const today = dayjs().format("YYYY-MM-DD");

        getAllOptionsforFilter(getOnlyDropdown, true);
        // if(fromDateValue == null || toDateValue === null){
        //     setFromDateValue(today);
        //     setToDateValue(today);
        // }

        // setShowFilterModal(true);
        setOthersFilterModal(true);

      } else {
        const errorMessage = viewTemplateResponse.message ? viewTemplateResponse.message : "Failed to Get Template. Please try again.";
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-error",
        });
      }

    } catch (error) {
      setLoading(false);
      if (error && error.response && error.response["data"]) {
        toast.error(error.response["data"].message ? error.response["data"].message : "Please Try Again !", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-error",
        });
      }
    }
  };
  

  const handleOtherClear = () => {
    setOtherSearchValue('');
    setOtherTemplatesPaginationCount(1);
    setOthersFromDate(null);
    setOthersToDate(null);
    setOthersFiltersDropdown([]);
    setOthersFilterData({});
    handleOtherTemplateActions(selectedOtherTemplate, selectedRowData, true)
  }

  const showOptionTemplate = async (tableName, approved) => {

    if (!tableName || tableName === "") {
      toast.warning("Please Check The Template", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "toast-warning",
      });
      return;
    }

    const viewTableData = {
      table_name: tableName,
    };
    setLoading(true);
    setOtherReadOnlyTemplateData(false);
    setOtherEditTemplateData(false);
    try {
      const viewTemplateResponse = await api.post(
        "/templates/viewTemplate",
        viewTableData
      );
      const ioUsers = await getIoUsers();
      const userId = localStorage.getItem("user_id");
      const userName = localStorage.getItem("username");

      setLoading(false);
      if (viewTemplateResponse && viewTemplateResponse.success) {
        var caseFields = [];
        var getCaseIdFields = viewTemplateResponse.data["fields"].map(
          (field) => {

            if (field.name === "field_assigned_by" && field.formType === "Dropdown") {

              field.options = ioUsers.map(user => ({
                code: user.user_id,
                name: user.name
              }));

              const matchedOption = field.options.find(opt => String(opt.code) === String(userId));
              if (!matchedOption) {
                field.options.push({ code: userId, name: userName || `User ${userId}` });
              }

              field.defaultValue = userId;
              field.disabled = true;
            }


            if (field && field.table && field.table === table_name) {
              caseFields = field;
              field.disabled = true;
            }

            return field;
          }
        );

        var initialData = {};
        if (caseFields && caseFields["name"]) {
          initialData = {
            [caseFields["name"]]: selectedRowData.id,
          };
        }

        setOtherFormOpen(true);
        setOtherInitialTemplateData(initialData);
        setviewReadonly(false);
        setEditTemplateData(false);
        setOptionFormTemplateData(getCaseIdFields ? getCaseIdFields : []);
        setChildTables(viewTemplateResponse?.["data"]?.["child_tables"] || []);
        if (
          viewTemplateResponse.data.no_of_sections &&
          viewTemplateResponse.data.no_of_sections > 0
        ) {
          setOptionStepperData(
            viewTemplateResponse.data.sections
              ? viewTemplateResponse.data.sections
              : []
          );
        }
      } else {
        const errorMessage = viewTemplateResponse.message
          ? viewTemplateResponse.message
          : "Failed to delete the template. Please try again.";
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-error",
        });
      }
    } catch (error) {
      setLoading(false);
      if (error && error.response && error.response["data"]) {
        toast.error(
          error.response["data"].message
            ? error.response["data"].message
            : "Please Try Again !",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            className: "toast-error",
          }
        );
      }
    }
  };

  const handleAutocomplete = (field, selectedValue, othersFilter) => {
    var updatedFormData = {}
    var selectedFilterDropdown = []

    if (othersFilter) {

      selectedFilterDropdown = othersFiltersDropdown
      updatedFormData = { ...othersFilterData, [field.name]: selectedValue };

      setOthersFilterData(updatedFormData);

    } else {

      selectedFilterDropdown = filterDropdownObj
      updatedFormData = { ...filterValues, [field.name]: selectedValue };

      setFilterValues(updatedFormData);

    }

    if (field?.api && field?.table) {
      var dependent_field = selectedFilterDropdown.filter((element) => {
        return (
          element.dependent_table &&
          element.dependent_table.length > 0 &&
          element.dependent_table.includes(field.table)
        );
      });

      if (dependent_field && dependent_field[0] && dependent_field[0].api) {
        var apiPayload = {};
        if (dependent_field[0].dependent_table.length === 1) {
          const key = field.table === "users" ? "user_id" : `${field.table}_id`;
          apiPayload = {
            [key]: updatedFormData[field.name],
          };
        } else {
          var dependentFields = selectedFilterDropdown.filter((element) => {
            return dependent_field[0].dependent_table.includes(element.table);
          });

          apiPayload = dependentFields.reduce((payload, element) => {
            if (updatedFormData && updatedFormData[element.name]) {
              const key =
                element.table === "users" ? "user_id" : `${element.table}_id`;
              payload[key] = updatedFormData[element.name];
            }
            return payload;
          }, {});
        }

        const callApi = async () => {
          setLoading(true);

          try {
            var getOptionsValue = await api.post(
              dependent_field[0].api,
              apiPayload
            );
            setLoading(false);

            var updatedOptions = [];

            if (getOptionsValue && getOptionsValue.data) {
              updatedOptions = getOptionsValue.data.map((element, i) => {
                return {
                  name: element[
                    dependent_field[0].table === "users"
                      ? "name"
                      : dependent_field[0].table + "_name"
                  ],
                  code: element[
                    dependent_field[0].table === "users"
                      ? "user_id"
                      : dependent_field[0].table + "_id"
                  ],
                };
              });
            }

            var userUpdateFields = {
              options: updatedOptions,
            };


            dependent_field.forEach((data) => {
              delete updatedFormData[data.name];
            });

            if (othersFilter) {
              setOthersFiltersDropdown(
                selectedFilterDropdown.map((element) => element.id === dependent_field[0].id ? { ...element, ...userUpdateFields } : element)
              );
              dependent_field.map((data) => {
                delete othersFilterData[data.name];
              });

              setOthersFilterData(updatedFormData);
            } else {
              setfilterDropdownObj(
                selectedFilterDropdown.map((element) => element.id === dependent_field[0].id ? { ...element, ...userUpdateFields } : element)
              );
              dependent_field.map((data) => {
                delete filterValues[data.name];
              });

              setFilterValues(updatedFormData);
            }

          } catch (error) {
            setLoading(false);
            if (error && error.response && error.response.data) {
              toast.error(
                error.response?.data?.message || "Need dependent Fields",
                {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  className: "toast-error",
                }
              );
              return;
            }
          }
        };
        callApi();
      }
    }
  };

  const getFileIcon = (fileName) => {
    fileName = fileName.split(".").pop().toLowerCase();
    switch (fileName) {
      case "pdf":
        return <img src={pdfIcon} />;
      case "jpg":
      case "jpeg":
        return <img src={jpgIcon} />;
      case "png":
      case "svg":
      case "gif":
        return <img src={pngIcon} />;
      case "xls":
      case "xlsx":
        return <img src={xlsIcon} />;
      case "csv":
      case "docx":
        return <img src={docxIcon} />;
      case "doc":
        return <img src={docIcon} />;
      case "ppt":
        return <img src={pptIcon} />;
      default:
        return <InsertDriveFileIcon />;
    }
  };

  const getAllOptionsforFilter = async (dropdownFields, others) => {
    try {
      setLoading(true);

      const apiCalls = dropdownFields
        .filter(
          (field) =>
            field.api === "/templateData/getTemplateData" && field.table
        )
        .map(async (field) => {
          try {
            const response = await api.post(field.api, {
              table_name: field.table,
            });

            if (!response.data) return { id: field.id, options: [] };

            const updatedOptions = response.data.map((templateData) => {
              const nameKey = Object.keys(templateData).find(
                (key) => !["id", "created_at", "updated_at"].includes(key)
              );
              return {
                name: nameKey ? templateData[nameKey] : "",
                code: templateData.id,
              };
            });

            return { id: field.id, options: updatedOptions };
          } catch (error) {
            return { id: field.id, options: [] };
          }
        });

      const results = await Promise.all(apiCalls);

      setLoading(false);
      var updatedFieldsDropdown = dropdownFields.map((field) => {
        const updatedField = results.find((res) => res.id === field.id);
        return updatedField
          ? { ...field, options: updatedField.options }
          : field;
      });

      if (others) {
        setOthersFiltersDropdown(updatedFieldsDropdown)
      } else {
        setfilterDropdownObj(updatedFieldsDropdown);
      }

    } catch (error) {
      setLoading(false);
      console.error("Error fetching template data:", error);
    }
  };

  const getIoUsers = async () => {
    const res = await api.post("cidMaster/getIoUsers");
    return res?.data || [];
  };

  const handleFileUpload = async (event) => {
    setLoading(true);
    const file = event.target.files[0];

    if (!file) {
      Swal.fire("Error", "Please select a file.", "error");
      return;
    }

    if (!selectedRowData || !selectedRowData.id) {
      Swal.fire("Error", "Invalid case ID.", "error");
      return;
    }

    const caseId = selectedRowData.id;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("ui_case_id", caseId);
    formData.append("created_by", "0");

    try {
      const response = await api.post("/templateData/uploadFile", formData);

      if (response.success) {
        Swal.fire("Success", "File uploaded successfully.", "success");
        setSelectedTab(1);
        // checkPdfEntryStatus(caseId);
        getUploadedFiles(selectedRowData);
      } else {
        Swal.fire("Error", response.message || "Upload failed.", "error");
      }
    } catch (error) {
      console.error("Upload error:", error);
      Swal.fire("Error", "Failed to upload file.", "error");
    } finally {
      setLoading(false);
    }
  };

  const onPR_FieldsUpdate = async (table_name, data) => {

    if (!table_name || table_name === "") {
      toast.warning("Please Check The Template");
      return;
    }

    if (!data || Object.keys(data).length === 0) {
      toast.warning("Data Is Empty Please Check Once");
      return;
    }

    const formData = new FormData();
    formData.append("table_name", table_name);

    let normalData = {};

    const allowedFields = [
      "field_brief_fact",
      "field_investigation_carried_out_by_the_police_station"
    ];

    allowedFields.forEach((key) => {
      const value = data[key];
      if (value !== undefined && value !== null && value !== "") {
        normalData[key] = value;
      }
    });

    formData.append("id", data.id);
    formData.append("data", JSON.stringify(normalData));
    formData.append("transaction_id", "TXN_" + Date.now() + "_" + Math.floor(Math.random() * 1000000));

    try {
      setLoading(true);
      const saveTemplateData = await api.post(
        "/templateData/updateTemplateData",
        formData
      );
      setLoading(false);

      if (saveTemplateData && saveTemplateData.success) {
        toast.success(saveTemplateData.message || "Data Updated Successfully", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-success",
        });
      } else {
        toast.error(saveTemplateData.message || "Failed to update the data.");
      }
    } catch (error) {
      setLoading(false);
      toast.error(
        error?.response?.data?.message || "Update failed. Please try again."
      );
    }
  };

  function sanitizeKey(str) {
        return str
            .toLowerCase()
            .replace(/[^\w]/g, "_")
            .replace(/_+/g, "_")
            .replace(/^_+|_+$/g, "");
        }
  const otherTemplateSaveFunc = async (data, saveNewAction) => {

    if ((!selectedOtherTemplate.table || selectedOtherTemplate.table === "")) {
      toast.warning("Please Check The Template", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "toast-warning",
      });
      return;
    }

    if (Object.keys(data).length === 0) {
      toast.warning("Data Is Empty Please Check Once", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "toast-warning",
      });
      return;
    }


    const formData = new FormData();

    var normalData = {}; // Non-file upload fields

    optionFormTemplateData.forEach((field) => {
      if (data[field.name]) {
        if (field.type === "file" || field.type === "profilepicture") {
          // Append file fields to formData
          if (field.type === "file") {
            if (Array.isArray(data[field.name])) {
              const hasFileInstance = data[field.name].some(
                (file) => file.filename instanceof File
              );
              var filteredArray = data[field.name].filter(
                (file) => file.filename instanceof File
              );
              if (hasFileInstance) {
                data[field.name].forEach((file) => {
                  if (file.filename instanceof File) {
                    formData.append(field.name, file.filename);
                  }
                });

                filteredArray = filteredArray.map((obj) => {
                  return {
                    ...obj,
                    filename: obj.filename["name"],
                  };
                });

                formData.append(
                  "folder_attachment_ids",
                  JSON.stringify(filteredArray)
                );
              }
            }
          } else {
            formData.append(field.name, data[field.name]);
          }
        } else {
          // Add non-file fields to normalData
          normalData[field.name] = Array.isArray(data[field.name]) ? data[field.name].join(",") : data[field.name]
        }
      }
    });

    let childTableDataMap = {};

    if (childTables && Array.isArray(childTables)) {
        childTables.forEach(child => {
            const childFieldName = child.field_name;

            if (data[childFieldName]) {
                let parsed;
                try {
                    parsed = typeof data[childFieldName] === "string"
                        ? JSON.parse(data[childFieldName])
                        : data[childFieldName];
                } catch (err) {
                    parsed = [];
                }

                if (Array.isArray(parsed)) {
                    const normalizedRows = parsed.map(row => {
                        let newRow = {};
                        for (const key in row) {
                            const sanitizedKey = sanitizeKey(key);
                            newRow[sanitizedKey] = row[key];
                        }
                        return newRow;
                    });

                    childTableDataMap[child.child_table_name] = normalizedRows;
                }
            }
        });
    }

    if (selectedOtherTemplate.table === "cid_ui_case_progress_report") {
      normalData["field_pr_status"] = "No";
    }

    normalData.sys_status = showPtCaseModal ? "pt_case" : "ui_case";
    normalData["ui_case_id"] = selectedRowData.id;

    var othersData = {};

    formData.append("table_name", showPtCaseModal ? ptCaseTableName : selectedOtherTemplate.table);
    formData.append("data", JSON.stringify(normalData));
    formData.append("child_tables", JSON.stringify(childTableDataMap));
    formData.append("others_data", JSON.stringify(othersData));
    formData.append("transaction_id", randomApprovalId);
    formData.append("user_designation_id", localStorage.getItem('designation_id') ? localStorage.getItem('designation_id') : null);

    setLoading(true);

    try {
      const overallSaveData = await api.post("/templateData/saveDataWithApprovalToTemplates", formData);

      setLoading(false);

      if (overallSaveData && overallSaveData.success) {

        toast.success(overallSaveData.message ? overallSaveData.message : "Case Updated Successfully", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-success",
        });

        if (fetchCounts) {
            fetchCounts();
        }
        if (saveNewAction) {
          await handleOtherTemplateActions(selectedOtherTemplate, selectedRow);
          showOptionTemplate(selectedOtherTemplate.table);
        } else {
          handleOtherTemplateActions(selectedOtherTemplate, selectedRow);
        }

        setOtherFormOpen(false);

        if (selectedOtherTemplate?.field) {
          var combinedData = {
            id: selectedRowData.id,
            [selectKey.name]: selectedOtherFields.code,
          };

          // update func
          onUpdateTemplateData(combinedData);

          setSelectKey(null);
          setSelectedRow(null);
          setSelectedOtherFields(null);
          setselectedOtherTemplate(null);
          setOtherTemplateModalOpen(false);
        } else {
          return;
        }

      } else {
        const errorMessage = overallSaveData.message ? overallSaveData.message : "Failed to change the status. Please try again.";
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-error",
        });
      }
    } catch (error) {
      setLoading(false);
      if (error && error.response && error.response["data"]) {
        toast.error(error.response["data"].message ? error.response["data"].message : "Please Try Again !", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-error",
        });
      }
    }
  };

  const otherTemplateUpdateFunc = async (data) => {
    if (!selectedOtherTemplate.table || selectedOtherTemplate.table === "") {
      toast.warning("Please Check The Template", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "toast-warning",
      });
      return;
    }

    if (Object.keys(data).length === 0) {
      toast.warning("Data Is Empty Please Check Once", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "toast-warning",
      });
      return;
    }

    const formData = new FormData();
    let normalData = {};
    let filteredFileArray = [];

    optionFormTemplateData.forEach((field) => {
      if (data[field.name]) {
        if (field.type === "file" || field.type === "profilepicture") {
          if (field.type === "file" && Array.isArray(data[field.name])) {
            const hasFileInstance = data[field.name].some(
              (file) => file.filename instanceof File
            );
            filteredFileArray = data[field.name].filter(
              (file) => file.filename instanceof File
            );

            if (hasFileInstance) {
              data[field.name].forEach((file) => {
                if (file.filename instanceof File) {
                  formData.append(field.name, file.filename);
                }
              });

              const folderInfo = filteredFileArray.map((file) => ({
                ...file,
                filename: file.filename.name,
              }));

              formData.append(
                "folder_attachment_ids",
                JSON.stringify(folderInfo)
              );
            }
          } else {
            formData.append(field.name, data[field.name]);
          }
        } else {
          normalData[field.name] = Array.isArray(data[field.name]) ? data[field.name].join(",") : data[field.name]
        }
      }
    });

    let childTableDataMap = {};

    if (childTables && Array.isArray(childTables)) {
        childTables.forEach(child => {
            const childFieldName = child.field_name;

            if (data[childFieldName]) {
                let parsed;
                try {
                    parsed = typeof data[childFieldName] === "string"
                        ? JSON.parse(data[childFieldName])
                        : data[childFieldName];
                } catch (err) {
                    parsed = [];
                }

                if (Array.isArray(parsed)) {
                    const normalizedRows = parsed.map(row => {
                        let newRow = {};
                        for (const key in row) {
                            const sanitizedKey = sanitizeKey(key);
                            newRow[sanitizedKey] = row[key];
                        }
                        return newRow;
                    });

                    childTableDataMap[child.child_table_name] = normalizedRows;
                }
            }
        });
    }

    if (data.hasOwnProperty("ui_case_id")) {
        normalData.ui_case_id = data.ui_case_id;
    }

    if (selectedOtherTemplate.table === "cid_ui_case_progress_report") {
      normalData["field_pr_status"] = "No";
    }

    formData.append("table_name", selectedOtherTemplate.table);
    formData.append("id", data.id);
    formData.append("data", JSON.stringify(normalData));
    formData.append("child_tables", JSON.stringify(childTableDataMap));
    formData.append("transaction_id", randomApprovalId);
    formData.append("user_designation_id", localStorage.getItem("designation_id") || null);

    let othersData = {};

    setLoading(true);

    try {
      const updateRes = await api.post(
        "/templateData/updateDataWithApprovalToTemplates",
        formData
      );
      setLoading(false);

      if (updateRes && updateRes.success) {
        toast.success(updateRes.message || "Data Updated Successfully", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-success",
          onOpen: () =>
            handleOtherTemplateActions(selectedOtherTemplate, selectedRow),
        });

        setOtherEditTemplateData(false);
        setOtherReadOnlyTemplateData(false);
      } else {
        const errorMessage =
          updateRes.message || "Failed to update. Please try again.";
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-error",
        });
      }
    } catch (error) {
      setLoading(false);
      toast.error(
        error?.response?.data?.message || "Update failed. Please try again.",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-error",
        }
      );
    }
  };

  const onUpdateTemplateData = async (data) => {

    if (!table_name || table_name === "") {
      toast.warning("Please Check The Template", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "toast-warning",
      });
      return;
    }

    if (Object.keys(data).length === 0) {
      toast.warning("Data Is Empty Please Check Once", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "toast-warning",
      });
      return;
    }

    const formData = new FormData();

    formData.append("table_name", table_name);
    var normalData = {}; // Non-file upload fields

    formTemplateData.forEach((field) => {
      if (data[field.name]) {
        if (field.type === "file" || field.type === "profilepicture") {
          // Append file fields to formData
          if (field.type === "file") {
            if (Array.isArray(data[field.name])) {
              const hasFileInstance = data[field.name].some(
                (file) => file.filename instanceof File
              );
              var filteredArray = data[field.name].filter(
                (file) => file.filename instanceof File
              );
              if (hasFileInstance) {
                data[field.name].forEach((file) => {
                  if (file.filename instanceof File) {
                    formData.append(field.name, file.filename);
                  }
                });

                filteredArray = filteredArray.map((obj) => {
                  return {
                    ...obj,
                    filename: obj.filename["name"],
                  };
                });
                formData.append(
                  "folder_attachment_ids",
                  JSON.stringify(filteredArray)
                );
              }
            }
          } else {
            formData.append(field.name, data[field.name]);
          }
        } else {
          // Add non-file fields to normalData
          normalData[field.name] = Array.isArray(data[field.name]) ? data[field.name].join(",") : data[field.name]
        }
      }
    });
    setLoading(true);
    formData.append("id", data.id);
    formData.append("data", JSON.stringify(normalData));

    try {
      const saveTemplateData = await api.post(
        "/templateData/updateTemplateData",
        formData
      );
      setLoading(false);

      if (saveTemplateData && saveTemplateData.success) {
        toast.success(saveTemplateData.message || "Data Updated Successfully", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-success",
        });

        setSelectKey(null);
        setSelectedRow([]);
        setSelectedOtherFields(null);
        setselectedOtherTemplate(null);
        setSelectedUser(null);
        setSelectedRowIds([]);
        setSelectedParentId(null);
      } else {
        const errorMessage = saveTemplateData.message
          ? saveTemplateData.message
          : "Failed to create the profile. Please try again.";
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-error",
        });
      }
    } catch (error) {
      setLoading(false);
      if (error && error.response && error.response["data"]) {
        toast.error(
          error.response["data"].message
            ? error.response["data"].message
            : "Please Try Again !",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            className: "toast-error",
          }
        );
      }
    }
  };

  const isSubmissionForCurrentMonth = (data) => {
    const now = new Date();
    return data.some(item => {
      const date = new Date(item.submission_date);
      return date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
    });
  };

  // Handle opening approval dialog
  const handleOpenApprovalDialog = async () => {
    setApprovalComment("");
    
    // Check if IO has already provided submission_date from monthwise table
    let existingSubmissionDate = null;
    try {
      // Fetch monthwise data to get submission_date
      const response = await api.post("/templateData/getMonthWiseByCaseId", {
        ui_case_id: rowId,
        page: 1,
        limit: 1, // Just need the latest one
      });
      
      if (response?.success && response.data && response.data.length > 0) {
        const latestMonthData = response.data[0];
        if (latestMonthData.submission_date) {
          existingSubmissionDate = dayjs(latestMonthData.submission_date);
          console.log("Found existing submission_date from IO:", existingSubmissionDate.format("YYYY-MM-DD"));
        }
      }
    } catch (error) {
      console.error("Error fetching submission_date:", error);
    }
    
    // Pre-fill with existing submission_date if available, otherwise use current date
    setApprovalDate(existingSubmissionDate || dayjs());
    setApprovalDialogOpen(true);
  };

  // Handle Submit Approval for Progress Report
  const handleSubmitApproval = async (comment = "", date = null) => {
    const defaultApprovalSteps = ["IO", "SP", "DIG", "ADGP", "DGP"];
    const approvalStepperArray = options?.approval_steps 
      ? (typeof options.approval_steps === "string" ? JSON.parse(options.approval_steps) : options.approval_steps)
      : defaultApprovalSteps;
    if (!approvalStepperArray.length) {
      toast.error("Approval steps not configured.", {
        position: "top-right",
        autoClose: 3000,
        className: "toast-error",
      });
      return;
    }

    let roleTitle = JSON.parse(localStorage.getItem("role_title")) || "";
    let designationName = (localStorage.getItem("designation_name") || "").toLowerCase();
    let stepperValue = "";

    if (roleTitle.toLowerCase() === "investigation officer") {
      stepperValue = "io";
    } else {
      // Check for full designation names first
      if (designationName.includes("director general of police") || designationName.includes("dgp")) {
        stepperValue = "dgp";
      } else if (designationName.includes("additional director general") || designationName.includes("adgp")) {
        stepperValue = "adgp";
      } else if (designationName.includes("deputy inspector general") || designationName.includes("dig")) {
        stepperValue = "dig";
      } else {
        // Fallback to first word
        const splitingValue = designationName.split(" ");
        if (splitingValue?.[0]) {
          stepperValue = splitingValue[0].toLowerCase();
        }
      }
    }

    // Find current step index
    const currentStepIndex = approvalStepperArray.findIndex(step => step.toLowerCase() === stepperValue);
    if (currentStepIndex === -1) {
      toast.error("Your role is not part of the approval workflow.", {
        position: "top-right",
        autoClose: 3000,
        className: "toast-error",
      });
      return;
    }

    // Check if previous steps are approved
    // Get approval_field_array from otherTemplateData if available, otherwise from selectedRowData
    let approvalFieldArray = [];
    
    if (otherTemplateData && otherTemplateData.length > 0) {
      const record = otherTemplateData[0];
      if (record.approval_field_array) {
        try {
          approvalFieldArray = typeof record.approval_field_array === "string"
            ? JSON.parse(record.approval_field_array)
            : record.approval_field_array;
        } catch (e) {
          approvalFieldArray = [];
        }
      }
    } else if (selectedRowData?.approval_field_array) {
      try {
        approvalFieldArray = typeof selectedRowData.approval_field_array === "string"
          ? JSON.parse(selectedRowData.approval_field_array)
          : selectedRowData.approval_field_array;
      } catch (e) {
        approvalFieldArray = [];
      }
    }
    
    const lastApprovedRole = approvalFieldArray.length > 0 ? approvalFieldArray[0] : null;
    const lastApprovedIndex = lastApprovedRole ? approvalStepperArray.indexOf(lastApprovedRole) : -1;

    // IO can always submit (first step)
    if (currentStepIndex === 0) {
      // IO submit logic - check if already submitted
      if (lastApprovedIndex >= 0 && lastApprovedIndex === currentStepIndex) {
        toast.error("IO has already submitted.", {
          position: "top-right",
          autoClose: 3000,
          className: "toast-error",
        });
        return;
      }
    } else {
      // Check if SP has approved (required for DIG/ADGP/DGP)
      const hasSPApproved = approvalFieldArray.includes("SP") || 
        approvalFieldArray.some(role => role.toUpperCase().includes("SP"));
      
      // Special logic for DGP: Can approve if SP has approved, even if DIG/ADGP haven't
      const isDGP = stepperValue === "dgp";
      if (isDGP) {
        if (!hasSPApproved) {
          toast.error("SP must approve before DGP can submit.", {
            position: "top-right",
            autoClose: 3000,
            className: "toast-error",
          });
          return;
        }
        // Check if DGP has already approved
        if (approvalFieldArray.includes("DGP")) {
          toast.error("DGP has already approved.", {
            position: "top-right",
            autoClose: 3000,
            className: "toast-error",
          });
          return;
        }
      } else {
        // For SP, DIG, ADGP: Can only submit if previous step is approved
        if (lastApprovedIndex < currentStepIndex - 1) {
          const previousStep = approvalStepperArray[currentStepIndex - 1];
          toast.error(`${previousStep} must approve before you can submit.`, {
            position: "top-right",
            autoClose: 3000,
            className: "toast-error",
          });
          return;
        }
        
        // Check if current step is already approved
        if (lastApprovedIndex >= currentStepIndex) {
          toast.error("This step has already been approved.", {
            position: "top-right",
            autoClose: 3000,
            className: "toast-error",
          });
          return;
        }
      }
    }

    // Check if comment is required (optional for DGP, required for others, NOT required for IO)
    const isDGP = stepperValue === "dgp";
    const isIO = stepperValue === "io";
    
    // If comment and date are not provided, use from state (for dialog submission)
    let finalComment = comment;
    let finalDate = date;
    
    // For IO, comment is not required, but we still allow date
    // For others, validate comment if not provided
    if (!isIO && !finalComment && !isDGP) {
      toast.error("Comment is required", {
        position: "top-right",
        autoClose: 3000,
        className: "toast-error",
      });
      return;
    }

    // Proceed with submission
    try {
      setLoading(true);
      
      // Get all records to update (for progress report, we update all records for the case)
      if (!otherTemplateData || otherTemplateData.length === 0) {
        toast.error("No records found to submit.", {
          position: "top-right",
          autoClose: 3000,
          className: "toast-error",
        });
        setLoading(false);
        return;
      }

      // Get current approval_field_array and add current step
      const currentApprovalArray = Array.isArray(approvalFieldArray) ? [...approvalFieldArray] : [];
      const currentStep = approvalStepperArray[currentStepIndex];
      
      // Add current step to the beginning of approval array if not already present
      if (!currentApprovalArray.includes(currentStep)) {
        currentApprovalArray.unshift(currentStep);
      }

      const formData = new FormData();
      const normalData = {};
      // Capture current user info to populate comment author fields when a role submits a comment
      const designationName = localStorage.getItem("designation_name") || "";
      const userName = localStorage.getItem("username") || "";
      const userId = localStorage.getItem("user_id") || "";
      
      // Set field_submit_status and sys_status based on role
      if (stepperValue === "io") {
        // IO submits approval with selected records
        if (!selectedIds || selectedIds.length === 0) {
          toast.error("Please select at least one record to submit.", {
            position: "top-right",
            autoClose: 3000,
            className: "toast-error",
          });
          setLoading(false);
          return;
        }
        
        // Add IO to approval_field_array
        const ioApprovalArray = ["IO"];
        normalData["approval_field_array"] = JSON.stringify(ioApprovalArray);
        normalData["field_submit_status"] = "submit";
        normalData["sys_status"] = "IO";
        // Store selected record IDs for PDF generation when SP submits
        normalData["io_selected_record_ids"] = JSON.stringify(selectedIds);
        // Update only selected records for IO
        var recordIds = selectedIds.join(",");
      } else {
        // For SP, DIG, ADGP, DGP - update approval_field_array and comment
        normalData["approval_field_array"] = JSON.stringify(currentApprovalArray);
        if (finalComment) {
          // Save comment to appropriate column based on role and also record who made the comment
          const commenter = designationName || userName || (userId ? `User ID: ${userId}` : "");
          if (stepperValue === "sp") {
            normalData["sp_comment"] = finalComment;
            normalData["sp_comment_by"] = commenter;
          } else if (stepperValue === "dig") {
            normalData["dig_comment"] = finalComment;
            normalData["dig_comment_by"] = commenter;
          } else if (stepperValue === "adgp") {
            normalData["adgp_comment"] = finalComment;
            normalData["adgp_comment_by"] = commenter;
          } else if (stepperValue === "dgp") {
            normalData["dgp_comment"] = finalComment;
            normalData["dgp_comment_by"] = commenter;
          }
        }
        
        // Add date if provided
        if (finalDate) {
          normalData["submission_date"] = dayjs(finalDate).format("YYYY-MM-DD");
        }
        
        // Get io_selected_record_ids from the first record (all records should have the same value)
        let ioSelectedRecordIds = [];
        if (otherTemplateData && otherTemplateData.length > 0) {
          const firstRecord = otherTemplateData[0];
          if (firstRecord.io_selected_record_ids) {
            try {
              ioSelectedRecordIds = typeof firstRecord.io_selected_record_ids === "string"
                ? JSON.parse(firstRecord.io_selected_record_ids)
                : firstRecord.io_selected_record_ids;
            } catch (e) {
              console.error("Error parsing io_selected_record_ids:", e);
            }
          }
        }
        
        // Update only IO selected records for SP/DIG/ADGP/DGP
        if (ioSelectedRecordIds.length > 0) {
          var recordIds = ioSelectedRecordIds.map(id => String(id)).join(",");
          // Also pass io_selected_record_ids in the data so backend can use it
          normalData["io_selected_record_ids"] = JSON.stringify(ioSelectedRecordIds);
        } else {
          // Fallback: if no io_selected_record_ids found, use all records (shouldn't happen)
          console.warn("handleSubmitApproval - No io_selected_record_ids found, using all records as fallback");
          var recordIds = otherTemplateData.map(record => record.id).join(",");
        }
      }

      formData.append("table_name", selectedOtherTemplate?.table || options?.table);
      formData.append("id", recordIds);
      formData.append("data", JSON.stringify(normalData));
      formData.append("transaction_id", randomApprovalId);
      formData.append("user_designation_id", localStorage.getItem("designation_id") || null);

      const updateRes = await api.post(
        "/templateData/updateDataWithApprovalToTemplates",
        formData
      );
      setLoading(false);

      if (updateRes && updateRes.success) {
        // Close dialog if it was open
        setApprovalDialogOpen(false);
        setApprovalComment("");
        setApprovalDate(null);
        
        toast.success(updateRes.message || "Approval submitted successfully", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-success",
          onOpen: () => {
            handleOtherTemplateActions(selectedOtherTemplate, selectedRow, false, true);
          },
        });
      } else {
        const errorMessage = updateRes.message || "Failed to submit approval. Please try again.";
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-error",
        });
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message || "Please Try Again!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "toast-error",
      });
    }
  };

  // Check if current user can submit approval
  const canSubmitApproval = () => {
    // Check if there are any records to approve
    if (!otherTemplateData || otherTemplateData.length === 0) {
      return false;
    }

    const defaultApprovalSteps = ["IO", "SP", "DIG", "ADGP", "DGP"];
    const approvalStepperArray = options?.approval_steps 
      ? (typeof options.approval_steps === "string" ? JSON.parse(options.approval_steps) : options.approval_steps)
      : defaultApprovalSteps;
    if (!approvalStepperArray.length) return false;

    let roleTitle = JSON.parse(localStorage.getItem("role_title")) || "";
    let designationName = (localStorage.getItem("designation_name") || "").toLowerCase();
    let stepperValue = "";

    if (roleTitle.toLowerCase() === "investigation officer") {
      stepperValue = "io";
    } else {
      // Check for full designation names first
      if (designationName.includes("director general of police") || designationName.includes("dgp")) {
        stepperValue = "dgp";
      } else if (designationName.includes("additional director general") || designationName.includes("adgp")) {
        stepperValue = "adgp";
      } else if (designationName.includes("deputy inspector general") || designationName.includes("dig")) {
        stepperValue = "dig";
      } else {
        // Fallback to first word
        const splitingValue = designationName.split(" ");
        if (splitingValue?.[0]) {
          stepperValue = splitingValue[0].toLowerCase();
        }
      }
    }

    const currentStepIndex = approvalStepperArray.findIndex(step => step.toLowerCase() === stepperValue);
    if (currentStepIndex === -1) {
      return false;
    }

    // Get approval_field_array from otherTemplateData if available, otherwise from selectedRowData
    let approvalFieldArray = [];
    
    if (otherTemplateData && otherTemplateData.length > 0) {
      const record = otherTemplateData[0];
      if (record.approval_field_array) {
        try {
          approvalFieldArray = typeof record.approval_field_array === "string"
            ? JSON.parse(record.approval_field_array)
            : record.approval_field_array;
        } catch (e) {
          approvalFieldArray = [];
        }
      }
    } else if (selectedRowData?.approval_field_array) {
      try {
        approvalFieldArray = typeof selectedRowData.approval_field_array === "string"
          ? JSON.parse(selectedRowData.approval_field_array)
          : selectedRowData.approval_field_array;
      } catch (e) {
        approvalFieldArray = [];
      }
    }
    
    const lastApprovedRole = approvalFieldArray.length > 0 ? approvalFieldArray[0] : null;
    const lastApprovedIndex = lastApprovedRole ? approvalStepperArray.indexOf(lastApprovedRole) : -1;

    // IO can submit only if not already submitted
    if (currentStepIndex === 0) {
      const canSubmit = lastApprovedIndex < 0 || !approvalFieldArray.includes("IO");
      return canSubmit;
    }

    // Check if SP has approved (required for DIG/ADGP/DGP)
    const hasSPApproved = approvalFieldArray.includes("SP") || 
      approvalFieldArray.some(role => role.toUpperCase().includes("SP"));

    // Check if IO has approved (required for SP)
    const hasIOApproved = approvalFieldArray.includes("IO") || 
      approvalFieldArray.some(role => role.toUpperCase().includes("IO"));

    // SP can only submit if IO has approved
    if (currentStepIndex === 1) { // SP is at index 1
      const canSubmit = hasIOApproved && !approvalFieldArray.includes("SP");
      return canSubmit;
    }

    // Special logic for DGP: Can approve if SP has approved, even if DIG/ADGP haven't
    const isDGP = stepperValue === "dgp";
    if (isDGP) {
      const canSubmit = hasSPApproved && !approvalFieldArray.includes("DGP");
      return canSubmit;
    }

    // Special logic for ADGP: Can approve if SP has approved, even if DIG hasn't
    const isADGP = stepperValue === "adgp";
    if (isADGP) {
      const canSubmit = hasSPApproved && !approvalFieldArray.includes("ADGP");
      return canSubmit;
    }

    // For DIG: Can submit only if SP has approved
    const isDIG = stepperValue === "dig";
    if (isDIG) {
      const canSubmit = hasSPApproved && !approvalFieldArray.includes("DIG");
      return canSubmit;
    }

    // Fallback: Can submit only if previous step is approved
    const canSubmit = lastApprovedIndex === currentStepIndex - 1;
    return canSubmit;
  };

  const handleSubmitClick = async () => {
    // Check if DGP has approved before allowing merge
    const defaultApprovalSteps = ["IO", "SP", "DIG", "ADGP", "DGP"];
    const approvalStepperArray = options?.approval_steps 
      ? (typeof options.approval_steps === "string" ? JSON.parse(options.approval_steps) : options.approval_steps)
      : defaultApprovalSteps;
    const approvalFieldArray = selectedRowData?.approval_field_array || [];
    
    if (approvalStepperArray.length > 0) {
      const dgpIndex = approvalStepperArray.findIndex(step => step.toLowerCase() === "dgp");
      if (dgpIndex !== -1) {
        const lastApprovedRole = approvalFieldArray[0];
        const lastApprovedIndex = approvalStepperArray.indexOf(lastApprovedRole);
        
        if (lastApprovedIndex < dgpIndex) {
          toast.error("Progress Report cannot be merged until DGP approves.", {
            position: "top-right",
            autoClose: 3000,
            className: "toast-warning",
          });
          return;
        }
      }
    }

    try {
      const response = await api.post("/templateData/getMonthWiseByCaseId", {
        ui_case_id: rowId,
        page: 1,
        limit: PageSize,
      });

      if (!selectedIds || selectedIds.length === 0) {
        toast.error("Please choose a record to append.", {
          position: "top-right",
          autoClose: 3000,
          className: "toast-warning",
        });
        return;
      }

      if (response?.success) {
        const hasCurrentMonthSubmission = isSubmissionForCurrentMonth(response.data || []);
        if (hasCurrentMonthSubmission) {
          handleUpdatePdfClick({
            selectedOtherTemplate,
            rowId,
            selectedIds,
            prUpdatePdf,
            submissionDate: null,
          });
        } else {
          setSubmissionDateDialogOpen(true);
        }
      } else {
        console.error("Failed to fetch month-wise data.");
      }
    } catch (err) {
      console.error("Error checking submission date:", err);
    }
  };

  const handleUpdatePdfClick = async ({ selectedOtherTemplate, rowId, selectedIds, prUpdatePdf ,submissionDate}) => {
    const getTemplatePayload = {
      table_name: selectedOtherTemplate?.table,
      ui_case_id: rowId,
    };

    // if (!selectedIds || selectedIds.length === 0) {
    //   toast.error("Please choose a record to append.", {
    //     position: "top-right",
    //     autoClose: 3000,
    //     className: "toast-warning",
    //   });
    //   return;
    // }

    setLoading(true);

    try {
      const getTemplateResponse = await api.post("/templateData/getTemplateData", getTemplatePayload);

      if (!getTemplateResponse?.success) {
        throw new Error(getTemplateResponse.message || "Failed to fetch template data.");
      }

      const dataToAppend = getTemplateResponse.data.filter(
        (item) => item.field_pr_status === "No"
      );

      const filteredDataToAppend = dataToAppend.filter(
        (item) => selectedIds.includes(item.id)
      );

      if (filteredDataToAppend.length === 0) {
        toast.error("These records have already been updated to the PDF.", {
          position: "top-right",
          autoClose: 3000,
          className: "toast-warning",
        });
        return;
      }

      const aoFieldValues = (await loadValueField(rowId, false, "cid_under_investigation")) || {};


      const aoFieldsToInclude = [
        "field_cid_crime_no./enquiry_no",
        "field_crime_number_of_ps",
        "field_name_of_the_police_station",
        "field_referring_agency",
        "field_dept_unit",
        "field_division",
      ];

      const filteredAOFieldValues = {};


        aoFieldsToInclude.forEach((key) => {
            const value = aoFieldValues[key];
            if (value !== undefined) {
                filteredAOFieldValues[key] = value;
            
                const field = aoFields.find(
                    (f) => f?.name === key && f.field_name === "Dropdown" && Array.isArray(f.options)
                );
            
                if (field) {
                    const matchedOption = field.options.find(
                    (opt) => opt?.code == value
                    );
            
                    if (matchedOption?.name) {
                        filteredAOFieldValues[key] = matchedOption.name;
                    }
                }
            } else {
                console.warn(`Field ${key} is missing or undefined.`);
            }
        });
      

      await prUpdatePdf({
        appendText: filteredDataToAppend,
        aoFields: filteredAOFieldValues,
        selectedIds,
        selectedRow: rowId,
        submissionDate
      });

    } catch (error) {
      console.error("Error in handleUpdatePdfClick:", error);
      toast.error("Error fetching template data. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        className: "toast-error",
      });
    } finally {
      setLoading(false);
    }
  };

  const prUpdatePdf = async ({ appendText, aoFields, selectedIds, selectedRow }) => {
    setLoading(true);

    try {
      const payload = {
        selected_row_id: selectedIds,
        ui_case_id: selectedRow,
        appendText,
        aoFields,
        created_by: localStorage.getItem("user_id"),
        submission_date: submissionDate, 
      };

      const saveTemplateData = await api.post(
        "/templateData/appendToLastLineOfPDF",
        payload
      );

      if (saveTemplateData?.success) {
        toast.success(saveTemplateData.message || "Data appended successfully.", {
          position: "top-right",
          autoClose: 3000,
          className: "toast-success",
        });

        setOtherTemplateModalOpen(false);
        setSelectedIds([]);
        handleOtherTemplateActions("cid_ui_case_progress_report", selectedRow, true, true);
        getUploadedFiles(selectedRow, options);
      } else {
        toast.error(saveTemplateData.message || "Failed to append data.", {
          position: "top-right",
          autoClose: true,
          className: "toast-error",
        });
      }
    } catch (error) {
      console.error("Error during PDF update:", error);
      toast.error(
        error?.response?.data?.message || "Error appending to PDF. Try again!",
        {
          position: "top-right",
          autoClose: 3000,
          className: "toast-error",
        }
      );
    } finally {
      setLoading(false);
    }
  };


  // --- Approval Stepper Logic ---
  // Default approval steps for Progress Report: IO → SP → DIG → ADGP → DGP
  const defaultApprovalSteps = ["IO", "SP", "DIG", "ADGP", "DGP"];
  const approvalStepperArray = options?.approval_steps 
    ? (typeof options.approval_steps === "string" ? JSON.parse(options.approval_steps) : options.approval_steps)
    : defaultApprovalSteps;
  
  // Get approval_field_array from progress report records, fallback to selectedRowData
  const getApprovalFieldArray = () => {
    if (otherTemplateData && otherTemplateData.length > 0) {
      const record = otherTemplateData[0];
      if (record.approval_field_array) {
        try {
          return typeof record.approval_field_array === "string" 
            ? JSON.parse(record.approval_field_array) 
            : record.approval_field_array;
        } catch (e) {
          return [];
        }
      }
    }
    // Fallback to selectedRowData
    if (selectedRowData?.approval_field_array) {
      try {
        return typeof selectedRowData.approval_field_array === "string"
          ? JSON.parse(selectedRowData.approval_field_array)
          : selectedRowData.approval_field_array;
      } catch (e) {
        return [];
      }
    }
    return [];
  };
  
  const approvalFieldArray = getApprovalFieldArray();

  // Check if DGP has approved (for preventing merge)
  const isDGPApproved = () => {
    if (!approvalStepperArray.length) return false;
    const dgpIndex = approvalStepperArray.findIndex(step => step.toLowerCase() === "dgp");
    if (dgpIndex === -1) return false;
    
    if (approvalFieldArray.length === 0) return false;
    
    const lastApprovedRole = approvalFieldArray[0];
    const lastApprovedIndex = approvalStepperArray.indexOf(lastApprovedRole);
    
    return lastApprovedIndex >= dgpIndex;
  };

  useEffect(() => {
    if (otherTemplateData.length > 0) {
      setCachedSysStatus(otherTemplateData[0].sys_status);
      setCachedSubmitStatus(otherTemplateData[0].field_submit_status);
    }
  }, [otherTemplateData]);

  return (
    <>
    <Box sx={{  overflow: 'auto' , height: '100vh'}}>
        {approvalStepperArray.length > 0 && (
          <Box sx={{ 
            display: "flex", 
            justifyContent: 'center', 
            alignItems: 'center', 
            mb: 2, 
            mt: 2,
            pt: 2,
            flexWrap: 'wrap',
            gap: 1,
            maxWidth: '100%',
            overflow: 'visible'
          }}>
            {approvalStepperArray.map((step, index) => {
              let selected = false;
              let roleTitle = JSON.parse(localStorage.getItem("role_title")) || "";
              let designationName = localStorage.getItem("designation_name") || "";
              let stepperValue = "";

              if (roleTitle.toLowerCase() === "investigation officer") {
                stepperValue = "io";
              } else {
                const splitingValue = designationName.split(" ");
                if (splitingValue?.[0]) {
                  stepperValue = splitingValue[0].toLowerCase();
                }
              }

              let alreadySubmited = false;
              let nextStageStep = false;
              let canSubmit = false;

              let sysStatus = otherTemplateData[0]?.sys_status || cachedSysStatus;
              let fieldSubmitStatus = otherTemplateData[0]?.field_submit_status || cachedSubmitStatus;
              let stepLower = step.toLowerCase();
              
              // Use approvalFieldArray as the source of truth for submitted status
              // Only mark steps as submitted if they are actually in the approval_field_array
              console.log(`🔍 Approval Status Check - Step: ${step}, approvalFieldArray:`, approvalFieldArray, "length:", approvalFieldArray.length);
              
              if (approvalFieldArray.length > 0) {
                const lastApprovedRole = approvalFieldArray[0];
                // Case-insensitive matching for role
                const lastApprovedIndex = approvalStepperArray.findIndex(
                  s => s.toLowerCase() === lastApprovedRole.toLowerCase()
                );

                console.log(`  - Last approved role: ${lastApprovedRole}, index: ${lastApprovedIndex}`);
                console.log(`  - approvalStepperArray:`, approvalStepperArray);

                if (lastApprovedIndex === -1) {
                  console.log(`  ⚠️ Warning: Last approved role "${lastApprovedRole}" not found in approvalStepperArray`);
                  // If role not found, treat as if no one has submitted
                  if (stepLower === "io") {
                    nextStageStep = true;
                    console.log(`  ⏳ Step "${step}" is marked as pending (role not found, defaulting to IO)`);
                  }
                } else {
                  // All steps up to and including the last approved role are submitted
                  const approvedStages = approvalStepperArray.slice(0, lastApprovedIndex + 1);

                  const nextStepIndex = lastApprovedIndex + 1;
                  const nextStep = nextStepIndex < approvalStepperArray.length 
                    ? approvalStepperArray[nextStepIndex] 
                    : null;

                  console.log(`  - Approved stages:`, approvedStages);
                  console.log(`  - Next step index: ${nextStepIndex}, Next step: ${nextStep}`);

                  // Case-insensitive comparison for step
                  const stepInApprovedStages = approvedStages.some(
                    s => s.toLowerCase() === step.toLowerCase()
                  );
                  
                  const isNextStep = nextStep && nextStep.toLowerCase() === step.toLowerCase();

                  if (stepInApprovedStages) {
                    alreadySubmited = true;
                    console.log(`  ✅ Step "${step}" is marked as submitted (in approved stages)`);
                  } else if (isNextStep) {
                    nextStageStep = true;
                    console.log(`  ⏳ Step "${step}" is next stage step`);
                  } else {
                    console.log(`  ❌ Step "${step}" is not submitted and not next step`);
                  }
                }
              } else {
                // If approval_field_array is empty, no one has submitted yet
                // Don't show "Submitted" status based on sys_status alone
                console.log(`  - approval_field_array is empty, checking if ${step} is first step`);
                // Only show "Pending" for the first step (IO) if no submissions exist
                if (stepLower === "io") {
                  nextStageStep = true; // IO is pending (first step)
                  console.log(`  ⏳ IO is marked as pending (first step, no submissions yet)`);
                } else {
                  console.log(`  ❌ Step "${step}" is not submitted (approval_field_array is empty)`);
                }
              }

              let statusLabel = "Not Approved";
              let statusClass = "submissionNotAssigned";

              if (alreadySubmited) {
                statusLabel = "Submitted";
                statusClass = "submissionCompleted";
              } else if (nextStageStep) {
                statusLabel = "Pending";
                statusClass = "submissionPending";
              }

              if (stepLower === stepperValue) {
                selected = true;
              }

              let StepperTitle = "";
              switch (stepLower) {
                case "io":
                  StepperTitle = "Investigation Officer";
                  break;
                case "sp":
                  StepperTitle = "Superintendent of Police";
                  break;
                case "dig":
                  StepperTitle = "Deputy Inspector General";
                  break;
                case "adgp":
                  StepperTitle = "Additional Director General of Police";
                  break;
                case "dgp":
                  StepperTitle = "Director General of Police";
                  break;
                default:
                  StepperTitle = "";
                  break;
              }

              return (
                <span key={step} style={{ display: "flex", alignItems: "center", padding: '5px' }}>
                  <Button
                    variant="contained"
                    onClick={() => {}}
                    sx={() => {
                      let backgroundColor = "#f0f0f0";
                      let color = "#333";
                      let boxShadow = "0 2px 6px rgba(0, 0, 0, 0.1)";

                      if (alreadySubmited) {
                        backgroundColor = "#27ae60";
                        color = "#fff";
                        boxShadow = "0 0 0 5px #d4f7e8";
                      } else if (nextStageStep) {
                        backgroundColor = "#ffd230";
                        color = "#333";
                        boxShadow = "0 0 0 5px #fff4cc ";
                      } else if (selected) {
                        backgroundColor = "#1570ef";
                        color = "#fff";
                        boxShadow = "0 0 0 5px #dcebff ";
                      }

                      return {
                        backgroundColor,
                        color,
                        minWidth: 40,
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        padding: '8px',
                        fontWeight: 600,
                        fontSize: '12px',
                        boxShadow,
                        transition: "all 0.3s ease-in-out",
                        transform: selected ? "translateY(-2px)" : "none",
                        "&:hover": {
                          backgroundColor: alreadySubmited
                            ? "#219150"
                            : nextStageStep
                              ? "#e6c200"
                              : selected
                                ? "#2980b9"
                                : "#dcdcdc",
                          boxShadow: alreadySubmited
                            ? "0 8px 16px rgba(39, 174, 96, 0.5)"
                            : nextStageStep
                              ? "0 8px 16px rgba(255, 210, 48, 0.5)"
                              : selected
                                ? "0 8px 16px rgba(52, 152, 219, 0.5)"
                                : "0 4px 10px rgba(0, 0, 0, 0.15)",
                          transform: "translateY(-3px)",
                        }
                      };
                    }}
                  >
                    {step}
                  </Button>
                  <Box px={1} sx={{ minWidth: 0, maxWidth: '120px' }}>
                    <Tooltip title={StepperTitle} arrow placement="top">
                      <div className="investigationStepperTitle" style={{ 
                        marginBottom: '2px',
                        fontSize: '11px',
                        lineHeight: '1.2',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}>
                        {StepperTitle}
                      </div>
                    </Tooltip>
                    <div className={`stepperCompletedPercentage ${statusClass}`} style={{ fontSize: '10px' }}>
                      {statusLabel}
                    </div>
                  </Box>
                  {index < approvalStepperArray.length - 1 && (
                    <Box
                      sx={{
                        width: 30,
                        minWidth: 30,
                      }}
                      className="divider"
                    />
                  )}
                </span>
              );
            })}
          </Box>
        )}

        <Box py={1} px={2} sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'start',}}>
            <Box
                sx={{
                width: '100%',
                bgcolor: 'background.paper',
                borderRadius: 2,
                zIndex: 1,
                }}
            >
                <Box
                sx={{
                    display: "flex",
                    alignItems: "start",
                    justifyContent: "space-between",
                    mb: 2
                }}
                >
                <Box
                    sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
                    onClick={() => backNavigation()}
                >
                    <WestIcon />
                    <Typography variant="body1" fontWeight={500}>
                    {selectedOtherTemplate?.name}
                    </Typography>

                    {/* {selectedRowData?.["field_cid_crime_no./enquiry_no"] && ( */}
                    {headerDetails && (
                        <Tooltip title={headerDetails}>
                        <Chip
                            label={
                            <Typography
                                sx={{
                                fontSize: '13px',
                                maxWidth: 230,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                fontWeight: 500, marginTop: '2px'
                                }}
                            >
                                {headerDetails}
                            </Typography>
                            }
                            color="primary"
                            variant="outlined"
                            size="small"
                            sx={{ fontWeight: 500, marginTop: '2px' }}
                        />
                        </Tooltip>
                    )}
                    {/* )} */}

                    {/* <Box className="totalRecordCaseStyle">
                    {otherTemplatesTotalRecord} Records
                    </Box> */}

                    {/* {APIsSubmited && (
                    <Box className="notifyAtTopCaseStyle">
                        Submission request in progress. Awaiting SP approval.
                    </Box>
                    )} */}
                </Box>

                {/* {hasPdfEntry && ( */}
                    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                    <Box
                        sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { xs: 'stretch', sm: 'center' },
                        justifyContent: 'space-between',
                        width: '100%',
                        gap: 2,
                        }}
                    >
                        <Box sx={{ display: 'none' }}></Box>

                    {selectedTab === 1 && (
                        <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: { xs: 'stretch', sm: 'flex-end' },
                            flexGrow: 1,
                        }}
                        >
                        <TextFieldInput
                            InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                <SearchIcon sx={{ color: "#475467" }} />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                <IconButton
                                    sx={{ px: 1, borderRadius: 0 }}
                                    onClick={() => handleOthersFilter(selectedOtherTemplate)}
                                >
                                    <FilterListIcon sx={{ color: "#475467" }} />
                                </IconButton>
                                </Box>
                            ),
                            }}
                            onInput={(e) => setOtherSearchValue(e.target.value)}
                            value={otherSearchValue}
                            id="tableSearch"
                            size="small"
                            placeholder="Search"
                            variant="outlined"
                            className="profileSearchClass"
                            onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                handleOtherTemplateActions(selectedOtherTemplate, selectedRowData);
                            }
                            }}
                            sx={{
                            width: { xs: '100%', sm: '250px' },
                            borderRadius: '6px',
                            '& .MuiInputBase-input::placeholder': {
                                color: '#475467',
                                opacity: 1,
                                fontSize: '14px',
                                fontWeight: 400,
                                fontFamily: 'Roboto',
                            },
                            }}
                        />

                        {(otherSearchValue || othersFromDate || othersToDate || Object.keys(othersFilterData).length > 0) && (
                            <Typography
                            onClick={handleOtherClear}
                            sx={{
                                fontSize: "13px",
                                fontWeight: "500",
                                textDecoration: "underline",
                                cursor: "pointer",
                                mt: 1,
                                textAlign: { xs: 'left', sm: 'right' },
                            }}
                            >
                            View all/Clear filter
                            </Typography>
                        )}
                        </Box>
                      )}
                        <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 1.5,
                            justifyContent: 'flex-end',
                            marginLeft: 'auto',
                        }}
                        >
                        <Button
                            sx={{height: "38px",}}
                            className="blueButton"
                            startIcon={
                                <AddIcon
                                    sx={{
                                        border: "1.3px solid #FFFFFF",
                                        borderRadius: "50%",
                                        background:"#4D4AF3 !important",
                                    }}
                                />
                            }
                            variant="contained"
                            onClick={() => showOptionTemplate(selectedOtherTemplate?.table)}
                        >
                            Add New
                        </Button>

                        {/* {showReplacePdfButton && (
                            <Button
                            variant="outlined"
                            component="label"
                            sx={{
                                height: '40px',
                                borderColor: '#d32f2f',
                                color: '#d32f2f',
                                textTransform: 'none',
                            }}
                            >
                            Replace PDF
                            <input
                                type="file"
                                hidden
                                accept="application/pdf"
                                onChange={(event) => handleFileUpload(event)}
                            />
                            </Button>
                        )} */}

                        {/* Submit Button - Integrated with approval functionality */}
                        <Button
                            onClick={() => {
                              // If user can submit approval, show approval dialog
                              // Otherwise, do normal submit
                              if (canSubmitApproval()) {
                                handleOpenApprovalDialog();
                              } else {
                                handleSubmitClick();
                              }
                            }}
                            variant="contained"
                            color="success"
                            disabled={
                              // For IO: enable if canSubmitApproval() is true (checkbox is selectable)
                              // For others: require canSubmitApproval() OR isDGPApproved(), AND isSubmitAllowed
                              canSubmitApproval() 
                                ? false 
                                : ((!canSubmitApproval() && !isDGPApproved()) || !isSubmitAllowed)
                            }
                            title={
                              !canSubmitApproval() && !isDGPApproved() && !isSubmitAllowed
                                ? "Submission is not allowed based on month submission rules" 
                                : (!canSubmitApproval() && !isDGPApproved() ? "DGP approval required before merging" : "")
                            }
                            // disabled={!isSubmitAllowed}
                            // sx={{
                            // height: '38px',
                            // backgroundColor: '#12B76A',
                            // color: 'white',
                            // textTransform: 'none',
                            // }}
                        >
                            Submit
                        </Button>
                        {
                            userPermissions && userPermissions?.[0]?.['bulk_upload'] === true &&
                            <Button
                                variant="contained"
                                color="success"
                                size="large"
                                sx={{ height: "38px" }}
                                onClick={showBulkUploadScreen}
                            >
                                Bulk Upload
                            </Button>
                        }
                        
                        {/* {
                            showMagazineView && 
                            <Button
                                onClick={()=>showMagazineView(false)}
                                sx={{height: "38px", textTransform: 'none'}}
                                className="whiteBorderedBtn"
                            >
                                Case Docket
                            </Button>
                        } */}
                        </Box>
                    </Box>
                    </Box>
                {/* // )} */}

                </Box>

                {/* {!hasPdfEntry ? (
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    height="200px"
                >
                    <Typography>Please Upload your Progress Report Pdf</Typography>
                    <Button variant="contained" component="label">
                    Upload File
                    <input
                        type="file"
                        hidden
                        accept="application/pdf"
                        onChange={(event) => handleFileUpload(event)}
                    />
                    </Button>
                </Box>
                ) : ( */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
                <Box pt={1} sx={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
                  <Box className="parentFilterTabs">
                    {["General Info", "Actions", "Monthwise PDF", "Final PDF"].map((label, index) => (
                      <Box
                        key={label}
                        onClick={() => setSelectedTab(index)}
                        className={`filterTabs ${selectedTab === index ? "Active" : ""}`}
                      >
                        {label}
                      </Box>
                    ))}
                  </Box>
                </Box>


                    {selectedTab === 0 && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginBottom: '10px', marginTop: '30px' }}>
                        {aoFields.length > 0 ? (
                        <Grid container spacing={2}>
                            {aoFields.map((field, index) => (
                              <Grid item xs={12} md={4} key={index}>
                                  {field.type === 'text' && (
                                  <ShortText
                                      key={field.id}
                                      field={field}
                                      formData={filterAoValues}
                                      disabled
                                  />
                                  )}

                                  {field.type === 'multidropdown' && (
                                  <MultiSelect
                                      key={field.id}
                                      field={field}
                                      formData={filterAoValues}
                                      onChange={(name, selectedCode) => handleAutocomplete(field, selectedCode)}
                                      disabled
                                  />
                                  )}

                                  {(field.type === 'dropdown' || field.type === 'autocomplete') && (
                                  <AutocompleteField
                                      key={field.id}
                                      field={field}
                                      formData={filterAoValues}
                                      onChange={(name, selectedCode) => handleAutocomplete(field, selectedCode)}
                                      value={(() => {
                                      const fieldValue = filterAoValues?.[field.name];
                                      return field.options.find(
                                          (opt) => String(opt.code) === String(fieldValue)
                                      ) || null;
                                      })()}
                                      disabled
                                  />
                                  )}

                                  {field.type === 'date' && (
                                  <DateField
                                      field={field}
                                      formData={filterAoValues}
                                      readOnly={true}
                                  />
                                  )}
                              </Grid>
                              ))}
                           
                            <Grid container item xs={12} spacing={2} alignItems="flex-start">
                            {aoFields
                                .slice(4)
                                .filter(f => f.type === 'textarea')
                                .map((field, index) => (
                                <Grid item xs={6} key={index}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    <label style={{ fontWeight: 'bold', color: 'black', marginRight: '10px' }}>
                                        {field.label}
                                    </label>
                                    <Tooltip title="Save">
                                        <Button variant="contained" color="primary" size="small" onClick={() => onPR_FieldsUpdate("cid_under_investigation", filterAoValues)}>Save</Button>
                                    </Tooltip>
                                    </div>
                                    <TextField
                                    fullWidth
                                    multiline
                                    minRows={10}
                                    maxRows={10}
                                    variant="outlined"
                                    value={filterAoValues[field.name] || ""}
                                    onChange={(e) =>
                                        setFilterAoValues((prev) => ({
                                        ...prev,
                                        [field.name]: e.target.value,
                                        }))
                                    }
                                    />
                                </Grid>
                                ))}
                            </Grid>
                        </Grid>
                        ) : (
                        <Typography variant="body2" color="text.secondary">
                            No AO Fields Available
                        </Typography>
                        )}
                    </Box>
                    )}
                </Box>
                {/* )} */}

                {selectedTab === 1 && (
                <Box>
                    <TableView
                    key={randomApprovalId}
                    rows={otherTemplateData}
                    columns={otherTemplateColumn}
                    totalPage={otherTemplatesTotalPage}
                    totalRecord={otherTemplatesTotalRecord}
                    paginationCount={otherTemplatesPaginationCount}
                    handlePagination={handleOtherPagination}
                    // handleRowClick={(row) =>
                    //   handleOthersTemplateDataView(row, false, selectedOtherTemplate?.table)
                    // }
                    tableName={selectedOtherTemplate?.table}
                    />
                </Box>
                )}

                {selectedTab === 2 && (
                <Box>
                    <TableView
                    rows={monthwiseData}
                    columns={monthwiseColumns}
                    totalPage={monthwiseTotalPage}
                    totalRecord={monthwiseTotalRecord}
                    paginationCount={monthwiseCurrentPage}
                    handlePagination={handleMonthwisePagination}
                    />
                </Box>
                )}

                {selectedTab === 3 && (
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    marginTop="50px"
                  >
                    <Typography variant="h6">Preview Uploaded PDF</Typography>

                    {uploadedFiles.length > 0 && uploadedFiles[0].file_path ? (
                      (() => {
                        const fullUrl = buildFileUrl(uploadedFiles[0].file_path);
                        console.log("Preview PDF - uploadedFiles:", uploadedFiles);
                        console.log("Preview PDF - fullUrl:", fullUrl);
                        return (
                          <Box sx={{ width: '100%', maxWidth: '900px' }}>
                            <Box sx={{ mb: 2, display: 'flex', gap: 2, alignItems: 'center', justifyContent: 'center' }}>
                              <Button
                                variant="outlined"
                                onClick={() => window.open(fullUrl, '_blank')}
                                sx={{ mb: 1 }}
                              >
                                Open PDF in New Tab
                              </Button>
                            </Box>
                            <Box 
                              sx={{ 
                                width: '100%', 
                                height: '600px',
                                border: '1px solid #ccc', 
                                borderRadius: '4px',
                                overflow: 'hidden',
                                backgroundColor: '#f5f5f5'
                              }}
                            >
                              <embed
                                key={fullUrl}
                                src={fullUrl}
                                type="application/pdf"
                                width="100%"
                                height="100%"
                                style={{ border: 'none' }}
                                title="Uploaded PDF Preview"
                              />
                            </Box>
                            <Box sx={{ mt: 2, p: 1, backgroundColor: '#f9f9f9', borderRadius: '4px' }}>
                              <Typography variant="caption" sx={{ display: 'block', wordBreak: 'break-all' }}>
                                <strong>PDF URL:</strong> {fullUrl}
                              </Typography>
                              <Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: 'text.secondary' }}>
                                <strong>File Name:</strong> {uploadedFiles[0].file_name}
                              </Typography>
                            </Box>
                          </Box>
                        );
                      })()
                    ) : (
                      <Box>
                        <Typography>No PDF found.</Typography>
                        <Typography variant="caption" sx={{ mt: 1, display: 'block', color: 'text.secondary' }}>
                          {uploadedFiles.length === 0 ? "No files loaded. Check console for errors." : "File path is missing."}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                )}

            </Box>
        </Box>
    </Box>


      {otherFormOpen && (
        <Dialog
          open={otherFormOpen}
          onClose={() => closeOtherForm}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xl"
          fullWidth
        >
          <DialogContent sx={{ minWidth: "400px", padding: '0' }}>
            <DialogContentText id="alert-dialog-description">
              <FormControl fullWidth>
                <NormalViewForm
                  table_row_id={otherRowId}
                  template_id={otherTemplateId}
                  template_name={
                    showPtCaseModal && ptCaseTemplateName
                      ? ptCaseTemplateName
                      : selectedOtherTemplate?.name
                  }
                  table_name={
                    showPtCaseModal && ptCaseTableName
                      ? ptCaseTableName
                      : selectedOtherTemplate?.table
                  }
                  readOnly={otherReadOnlyTemplateData}
                  editData={otherEditTemplateData}
                  initialData={otherInitialTemplateData}
                  formConfig={optionFormTemplateData}
                  stepperData={optionStepperData}
                  onSubmit={otherTemplateSaveFunc}
                  onUpdate={otherTemplateUpdateFunc}
                  disableEditButton={disableEditButtonFlag}
                  onError={onSaveTemplateError}
                  closeForm={closeOtherForm}
                  headerDetails={selectedRowData?.["field_cid_crime_no./enquiry_no"]}
                />
              </FormControl>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ padding: "12px 24px" }}>
            <Button onClick={closeOtherForm}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}

      <Dialog 
        open={submissionDateDialogOpen} 
        onClose={() => setSubmissionDateDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Select Submission Date</DialogTitle>
        <DialogContent>
          <TextField
            type="date"
            fullWidth
            value={submissionDate || ""}
            onChange={(e) => setSubmissionDate(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSubmissionDateDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={() => {
              setSubmissionDateDialogOpen(false);
              handleUpdatePdfClick({
                selectedOtherTemplate,
                rowId,
                selectedIds,
                prUpdatePdf,
                submissionDate
              });
            }}
            variant="contained"
            disabled={!submissionDate}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* Approval Dialog with Date, Comment, and Submit */}
      <Dialog 
        open={approvalDialogOpen} 
        onClose={() => {
          setApprovalDialogOpen(false);
          setApprovalComment("");
          setApprovalDate(null);
        }}
        aria-labelledby="approval-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="approval-dialog-title">
          Submit Approval
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Submission Date"
                value={approvalDate}
                onChange={(newValue) => {
                  setApprovalDate(newValue);
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                  }
                }}
              />
            </LocalizationProvider>
            {(() => {
              const roleTitle = JSON.parse(localStorage.getItem("role_title")) || "";
              const designationName = (localStorage.getItem("designation_name") || "").toLowerCase();
              const isIO = roleTitle.toLowerCase() === "investigation officer";
              const isDGP = designationName.includes("director general of police") || designationName.includes("dgp");
              
              // For IO: Don't show comment field
              if (isIO) {
                return null;
              }
              
              // For DGP: Optional comment
              // For others (SP, DIG, ADGP): Required comment
              return (
                <TextField
                  multiline
                  rows={4}
                  label={isDGP ? "Comment (Optional)" : "Comment "}
                  placeholder={isDGP ? "Enter your comment here (optional)..." : "Enter your comment here..."}
                  value={approvalComment}
                  onChange={(e) => setApprovalComment(e.target.value)}
                  fullWidth
                  size="small"
                  required={!isDGP} // Required for SP, DIG, ADGP; optional for DGP
                />
              );
            })()}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => {
              setApprovalDialogOpen(false);
              setApprovalComment("");
              setApprovalDate(null);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              // Validate comment if required
              const roleTitle = JSON.parse(localStorage.getItem("role_title")) || "";
              const designationName = (localStorage.getItem("designation_name") || "").toLowerCase();
              const isDGP = designationName.includes("director general of police") || designationName.includes("dgp");
              const isIO = roleTitle.toLowerCase() === "investigation officer";
              
              if (!isIO && !isDGP && !approvalComment.trim()) {
                toast.error("Comment is required", {
                  position: "top-right",
                  autoClose: 3000,
                });
                return;
              }
              
              handleSubmitApproval(approvalComment, approvalDate);
            }}
            variant="contained"
            color="primary"
          >
            Submit Approval
          </Button>
        </DialogActions>
      </Dialog>

      {loading && (
        <div className="parent_spinner" tabIndex="-1" aria-hidden="true">
          <CircularProgress size={100} />
        </div>
      )}

      {
        bulkUploadShow &&
            <Dialog
                open={bulkUploadShow}
                onClose={()=>setBulkUploadShow(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{ sx: { borderRadius: 3, p: 2} }}
            >
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <DialogTitle sx={{ fontWeight: 600, fontSize: '20px', pb: 0  }}>Excel Upload</DialogTitle>
                    <IconButton onClick={()=>setBulkUploadShow(false)}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <DialogContent>
                    <Typography sx={{ mb: 2 }}>
                        Please check Excel header before upload. If needed,&nbsp;
                        <Link onClick={downloadExcelHeader} underline="hover" rel="noopener" sx={{cursor: 'pointer'}}>
                            Download here
                        </Link>
                    </Typography>

                    <Box
                        component="label"
                        htmlFor="excel-upload"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            border: '2px dashed #1976d2',
                            p: 5,
                            textAlign: 'center',
                            borderRadius: 2,
                            backgroundColor: '#f9f9f9',
                            cursor: 'pointer',
                            '&:hover': { backgroundColor: '#f0f0f0' },
                        }}
                    >
                        <UploadFileIcon sx={{ fontSize: 48, color: '#1976d2', mb: 1 }} />
                        <Typography variant="h6" fontWeight={500} sx={{ color: '#555' }}>
                            Click here to upload Excel file
                        </Typography>
                        <input
                            type="file"
                            accept=".xlsx, .xls"
                            id="excel-upload"
                            hidden
                            onChange={handleFileChange}
                        />
                    </Box>

                    {selectedFile && (
                        <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                            <Typography mt={2} color="blue">
                                Selected File: {selectedFile.name}
                            </Typography>
                            <Button
                                variant="contained"
                                color="success"
                                sx={{ mt: 2, textTransform: 'uppercase', fontWeight: 500 }}
                                startIcon={<UploadFileIcon />}
                                onClick={checkUploadedFile}
                            >
                                Upload
                            </Button>
                        </Box>
                    )}
                </DialogContent>
            </Dialog>
        }

      {othersFilterModal && (
          <Dialog
              open={othersFilterModal}
              onClose={() => setOthersFilterModal(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="md"
              fullWidth
          >

              <DialogTitle
                  id="alert-dialog-title"
                  sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                  }}
              >
                  Filter
                  <IconButton
                      aria-label="close"
                      onClick={() => setOthersFilterModal(false)}
                      sx={{ color: (theme) => theme.palette.grey[500] }}
                  >
                      <CloseIcon />
                  </IconButton>
              </DialogTitle>

          <DialogContent sx={{ minWidth: "400px" }}>
              <DialogContentText id="alert-dialog-description">
                  <Grid container sx={{ alignItems: "center" }}>
                      <Grid item xs={12} md={6} p={2}>
                         <h4 className="form-field-heading">From Date</h4>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                  format="DD-MM-YYYY"
                                  sx={{
                                      width: "100%",
                                  }}
                                  label="From Date"
                                  value={othersFromDate ? dayjs(othersFromDate) : null}
                                  onChange={(e) =>
                                      setOthersFromDate(e ? e.format("YYYY-MM-DD") : null)
                                  }
                              />
                          </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12} md={6} p={2}>
                          <h4 className="form-field-heading">To Date</h4>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                  format="DD-MM-YYYY"
                                  sx={{
                                      width: "100%",
                                  }}
                                  label="To Date"
                                  value={othersToDate ? dayjs(othersToDate) : null}
                                  onChange={(e) =>
                                      setOthersToDate(e ? e.format("YYYY-MM-DD") : null)
                                  }
                              />
                          </LocalizationProvider>
                      </Grid>

                      {othersFiltersDropdown.map((field) => {
                          if (field?.hide_from_ux) {
                            return null;
                          }

                          if (!field?.table_display_content) {
                            return null;
                          }
                          switch (field.type) {
                              case "dropdown":
                              return (
                                  <Grid item xs={12} md={6} p={2}>
                                  <div className="form-field-wrapper_selectedField">
                                      <SelectField
                                      key={field.id}
                                      field={field}
                                      formData={othersFilterData}
                                      onChange={(value) =>
                                          handleAutocomplete(field, value.target.value, true)
                                      }
                                      />
                                  </div>
                                  </Grid>
                              );

                              case "multidropdown":
                              return (
                                  <Grid item xs={12} md={6} p={2}>
                                  <MultiSelect
                                      key={field.id}
                                      field={field}
                                      formData={othersFilterData}
                                      onChange={(name, selectedCode) =>
                                          handleAutocomplete(field, selectedCode, true)
                                      }
                                  />
                                  </Grid>
                              );

                              case "autocomplete":
                              return (
                                  <Grid item xs={12} md={6} p={2}>
                                  <AutocompleteField
                                      key={field.id}
                                      field={field}
                                      formData={othersFilterData}
                                      onChange={(name, selectedCode) =>
                                          handleAutocomplete(field, selectedCode, true)
                                      }
                                  />
                                  </Grid>
                              );

                              case "date":
                                return (
                                    <Grid item xs={12} md={6} p={2} key={field.id}>
                                        <div className="form-field-wrapper_selectedField">
                                            <DateField
                                                key={field.id}
                                                field={field}
                                                formData={othersFilterData}
                                                 onChange={(date) => {
                                                  const formattedDate = date ? dayjs(date).format("YYYY-MM-DD") : null;
                                                  setOthersFilterData((prev) => ({
                                                    ...prev,
                                                    [field.name]: formattedDate,
                                                  }));
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                );
                                case "datetime":
                                    return (
                                        <Grid item xs={12} md={6} p={2} key={field.id}>
                                            <div className="form-field-wrapper_selectedField">
                                                <DateTimeField
                                                    key={field.id}
                                                    field={field}
                                                    formData={othersFilterData}
                                                    onChange={(date) => {
                                                        const formattedDateTime = date
                                                            ? dayjs(date).format("YYYY-MM-DD HH:mm:ss")
                                                            : null;
                                                        setOthersFilterData((prev) => ({
                                                            ...prev,
                                                            [field.name]: formattedDateTime,
                                                        }));
                                                    }}
                                                />
                                            </div>
                                        </Grid>
                                    );
                                                       
                                // case "time":
                                //     return (
                                //         <Grid item xs={12} md={6} p={2} key={field.id}>
                                //             <div className="form-field-wrapper_selectedField">
                                //                 <TimeField
                                //                     key={field.id}
                                //                     field={field}
                                //                     formData={othersFilterData}
                                //                     onChange={(time) => {
                                //                         const formattedTime = time
                                //                             ? dayjs(time).format("HH:mm:ss")
                                //                             : null;
                                //                         setOthersFilterData((prev) => ({
                                //                             ...prev,
                                //                             [field.name]: formattedTime,
                                //                         }));
                                //                     }}
                                //                 />
                                //             </div>
                                //         </Grid>
                                //     );

                      }
                      })}
                  </Grid>
              </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ padding: "12px 24px" }}>
              <Button onClick={() => setOthersFilterModal(false)}>Close</Button>
              <Button
                  className="fillPrimaryBtn"
                  sx={{ minWidth: "100px" }}
                  onClick={() => setOtherFilterData()}
              >
                  Apply
              </Button>
          </DialogActions>
          </Dialog>
      )}
    </>
  );
};


export default ProgressReport;